var items = {
  "block.minecraft.acacia_button": "Botón d'alcacia",
  "block.minecraft.acacia_door": "Puerta d'alcacia",
  "block.minecraft.acacia_fence": "Valla d'alcacia",
  "block.minecraft.acacia_fence_gate": "Portiella d'alcacia",
  "block.minecraft.acacia_hanging_sign": "Cartel colgante d'acaciu",
  "block.minecraft.acacia_leaves": "Fueyes d'alcacia",
  "block.minecraft.acacia_log": "Tueru d'alcacia",
  "block.minecraft.acacia_planks": "Tables d'alcacia",
  "block.minecraft.acacia_pressure_plate": "Placa de presión d'alcacia",
  "block.minecraft.acacia_sapling": "Biltu d'alcacia",
  "block.minecraft.acacia_shelf": "Estantería d'alcacia",
  "block.minecraft.acacia_sign": "Cartelu d'alcacia",
  "block.minecraft.acacia_slab": "Llábana d'alcacia",
  "block.minecraft.acacia_stairs": "Pasales d'alcacia",
  "block.minecraft.acacia_trapdoor": "Trapiella d'alcacia",
  "block.minecraft.acacia_wall_hanging_sign": "Cartel colgante d'acaciu pa la pared",
  "block.minecraft.acacia_wall_sign": "Cartelu d'alcacia na parede",
  "block.minecraft.acacia_wood": "Madera d'alcacia con corteza",
  "block.minecraft.activator_rail": "Vía activadora",
  "block.minecraft.air": "Aire",
  "block.minecraft.allium": "Ayu bravu",
  "block.minecraft.amethyst_block": "Bloque d'amatista",
  "block.minecraft.amethyst_cluster": "Conxuntu d'amatistas",
  "block.minecraft.ancient_debris": "Escombrios antiguos",
  "block.minecraft.andesite": "Andesita",
  "block.minecraft.andesite_slab": "Llábana d'andesita",
  "block.minecraft.andesite_stairs": "Pasales d'andesita",
  "block.minecraft.andesite_wall": "Muria d'andesita",
  "block.minecraft.anvil": "Xuncla",
  "block.minecraft.attached_melon_stem": "Tallu de sandía xuníu",
  "block.minecraft.attached_pumpkin_stem": "Tallu de calabaza xuníu",
  "block.minecraft.azalea": "Rododendru",
  "block.minecraft.azalea_leaves": "Fueyes de rododendru",
  "block.minecraft.azure_bluet": "Houstonia caerulea",
  "block.minecraft.bamboo": "Bambú",
  "block.minecraft.bamboo_block": "Bloquéu de bambú",
  "block.minecraft.bamboo_button": "Botón de bambú",
  "block.minecraft.bamboo_door": "Puerta de bambú",
  "block.minecraft.bamboo_fence": "Cercáu de bambú",
  "block.minecraft.bamboo_fence_gate": "Puerta de cercáu de bambú",
  "block.minecraft.bamboo_hanging_sign": "Cartelu colgante de bambú",
  "block.minecraft.bamboo_mosaic": "Mosaico de bambú",
  "block.minecraft.bamboo_mosaic_slab": "Lladríu de mosaico de bambú",
  "block.minecraft.bamboo_mosaic_stairs": "Escaleres de mosaicu de bambú",
  "block.minecraft.bamboo_planks": "Tablones de bambú",
  "block.minecraft.bamboo_pressure_plate": "Placa de presión de bambú",
  "block.minecraft.bamboo_sapling": "Biltu de bambú",
  "block.minecraft.bamboo_shelf": "Estantería de bambú",
  "block.minecraft.bamboo_sign": "Cartelu de bambú",
  "block.minecraft.bamboo_slab": "Madera de bambú",
  "block.minecraft.bamboo_stairs": "Escaleres de bambú",
  "block.minecraft.bamboo_trapdoor": "Portella trampa de bambú",
  "block.minecraft.bamboo_wall_hanging_sign": "Cartelu de bambú pa colgar na paret",
  "block.minecraft.bamboo_wall_sign": "Cartelu de bambú pa pindiar na pared",
  "block.minecraft.banner.base.black": "Estandarte en prieto",
  "block.minecraft.banner.base.blue": "Estandarte n'azul",
  "block.minecraft.banner.base.brown": "Estandarte en marrón",
  "block.minecraft.banner.base.cyan": "Estandarte en ciano",
  "block.minecraft.banner.base.gray": "Estandarte en buxo",
  "block.minecraft.banner.base.green": "Estandarte en verde",
  "block.minecraft.banner.base.light_blue": "Estandarte n'azul claro",
  "block.minecraft.banner.base.light_gray": "Estandarte en buxo claro",
  "block.minecraft.banner.base.lime": "Estandarte en llima",
  "block.minecraft.banner.base.magenta": "Estandarte en maxenta",
  "block.minecraft.banner.base.orange": "Estandarte en naranxa",
  "block.minecraft.banner.base.pink": "Estandarte en rosa",
  "block.minecraft.banner.base.purple": "Estandarte en morao",
  "block.minecraft.banner.base.red": "Estandarte en colorao",
  "block.minecraft.banner.base.white": "Estandarte en blanco",
  "block.minecraft.banner.base.yellow": "Estandarte en mariello",
  "block.minecraft.banner.border.black": "Berbesu prietu",
  "block.minecraft.banner.border.blue": "Berbesu azul",
  "block.minecraft.banner.border.brown": "Berbesu marrón",
  "block.minecraft.banner.border.cyan": "Berbesu cianu",
  "block.minecraft.banner.border.gray": "Berbesu buxu",
  "block.minecraft.banner.border.green": "Berbesu verde",
  "block.minecraft.banner.border.light_blue": "Berbesu azul claru",
  "block.minecraft.banner.border.light_gray": "Berbesu buxu claru",
  "block.minecraft.banner.border.lime": "Berbesu llima",
  "block.minecraft.banner.border.magenta": "Berbesu maxenta",
  "block.minecraft.banner.border.orange": "Berbesu naranxa",
  "block.minecraft.banner.border.pink": "Berbesu rosa",
  "block.minecraft.banner.border.purple": "Berbesu moráu",
  "block.minecraft.banner.border.red": "Berbesu coloráu",
  "block.minecraft.banner.border.white": "Berbesu blancu",
  "block.minecraft.banner.border.yellow": "Berbesu mariellu",
  "block.minecraft.banner.bricks.black": "Enlladriyao prieto",
  "block.minecraft.banner.bricks.blue": "Enlladriyao azul",
  "block.minecraft.banner.bricks.brown": "Enlladriyao marrón",
  "block.minecraft.banner.bricks.cyan": "Enlladriyao cian",
  "block.minecraft.banner.bricks.gray": "Enlladriyao buxu",
  "block.minecraft.banner.bricks.green": "Enlladriyao verde",
  "block.minecraft.banner.bricks.light_blue": "Enlladriyao azul claro",
  "block.minecraft.banner.bricks.light_gray": "Enlladriyao buxu claru",
  "block.minecraft.banner.bricks.lime": "Enlladriyao llima",
  "block.minecraft.banner.bricks.magenta": "Enlladriyao maxenta",
  "block.minecraft.banner.bricks.orange": "Enlladriyao naranxa",
  "block.minecraft.banner.bricks.pink": "Enlladriyao rosa",
  "block.minecraft.banner.bricks.purple": "Enlladriyao moráu",
  "block.minecraft.banner.bricks.red": "Enlladriyao colorao",
  "block.minecraft.banner.bricks.white": "Enlladriyao blanco",
  "block.minecraft.banner.bricks.yellow": "Enlladriyao mariello",
  "block.minecraft.banner.circle.black": "Redondel prietu",
  "block.minecraft.banner.circle.blue": "Redondel azul",
  "block.minecraft.banner.circle.brown": "Redondel marrón",
  "block.minecraft.banner.circle.cyan": "Redondel cianu",
  "block.minecraft.banner.circle.gray": "Redondel buxu",
  "block.minecraft.banner.circle.green": "Redondel verde",
  "block.minecraft.banner.circle.light_blue": "Redondel azul claru",
  "block.minecraft.banner.circle.light_gray": "Redondel buxu claro",
  "block.minecraft.banner.circle.lime": "Redondel llima",
  "block.minecraft.banner.circle.magenta": "Redondel maxenta",
  "block.minecraft.banner.circle.orange": "Redondel naranxa",
  "block.minecraft.banner.circle.pink": "Redondel rosa",
  "block.minecraft.banner.circle.purple": "Redondel moráu",
  "block.minecraft.banner.circle.red": "Redondel coloráu",
  "block.minecraft.banner.circle.white": "Redondel blancu",
  "block.minecraft.banner.circle.yellow": "Redondel mariellu",
  "block.minecraft.banner.creeper.black": "Dibuxu prietu de Creeper",
  "block.minecraft.banner.creeper.blue": "Dibuxu azul de Creeper",
  "block.minecraft.banner.creeper.brown": "Dibuxu marrón de Creeper",
  "block.minecraft.banner.creeper.cyan": "Dibuxu cian de Creeper",
  "block.minecraft.banner.creeper.gray": "Dibuxu buxu de Creeper",
  "block.minecraft.banner.creeper.green": "Dibuxu verde de Creeper",
  "block.minecraft.banner.creeper.light_blue": "Dibuxu azul claru de Creeper",
  "block.minecraft.banner.creeper.light_gray": "Dibuxu buxu claru de Creeper",
  "block.minecraft.banner.creeper.lime": "Dibuxu llima de Creeper",
  "block.minecraft.banner.creeper.magenta": "Dibuxu maxenta de Creeper",
  "block.minecraft.banner.creeper.orange": "Dibuxu naranxa de Creeper",
  "block.minecraft.banner.creeper.pink": "Dibuxu rosa de Creeper",
  "block.minecraft.banner.creeper.purple": "Dibuxu moráu de Creeper",
  "block.minecraft.banner.creeper.red": "Dibuxu coloráu de Creeper",
  "block.minecraft.banner.creeper.white": "Dibuxu blancu de Creeper",
  "block.minecraft.banner.creeper.yellow": "Dibuxu mariellu de Creeper",
  "block.minecraft.banner.cross.black": "Nasa prieta",
  "block.minecraft.banner.cross.blue": "Nasa azul",
  "block.minecraft.banner.cross.brown": "Nasa marrón",
  "block.minecraft.banner.cross.cyan": "Nasa ciana",
  "block.minecraft.banner.cross.gray": "Nasa buxa",
  "block.minecraft.banner.cross.green": "Nasa verde",
  "block.minecraft.banner.cross.light_blue": "Nasa azul clara",
  "block.minecraft.banner.cross.light_gray": "Nasa buxa clara",
  "block.minecraft.banner.cross.lime": "Nasa llima",
  "block.minecraft.banner.cross.magenta": "Nasa maxenta",
  "block.minecraft.banner.cross.orange": "Nasa naranxa",
  "block.minecraft.banner.cross.pink": "Nasa rosa",
  "block.minecraft.banner.cross.purple": "Nasa morada",
  "block.minecraft.banner.cross.red": "Nasa colorada",
  "block.minecraft.banner.cross.white": "Nasa blanca",
  "block.minecraft.banner.cross.yellow": "Nasa mariella",
  "block.minecraft.banner.curly_border.black": "Berbesu dentáu en prieto",
  "block.minecraft.banner.curly_border.blue": "Berbesu dentáu n'azul",
  "block.minecraft.banner.curly_border.brown": "Berbesu dentáu en marrón",
  "block.minecraft.banner.curly_border.cyan": "Berbesu dentáu en ciano",
  "block.minecraft.banner.curly_border.gray": "Berbesu dentáu en buxo",
  "block.minecraft.banner.curly_border.green": "Berbesu dentáu en verde",
  "block.minecraft.banner.curly_border.light_blue": "Berbesu dentáu n'azul claro",
  "block.minecraft.banner.curly_border.light_gray": "Berbesu dentáu en buxo claro",
  "block.minecraft.banner.curly_border.lime": "Berbesu dentáu en llima",
  "block.minecraft.banner.curly_border.magenta": "Berbesu dentáu en maxenta",
  "block.minecraft.banner.curly_border.orange": "Berbesu dentáu en naranxa",
  "block.minecraft.banner.curly_border.pink": "Berbesu dentáu en rosa",
  "block.minecraft.banner.curly_border.purple": "Berbesu dentáu en morao",
  "block.minecraft.banner.curly_border.red": "Berbesu dentáu en colorao",
  "block.minecraft.banner.curly_border.white": "Berbesu dentáu en blanco",
  "block.minecraft.banner.curly_border.yellow": "Berbesu dentáu en mariello",
  "block.minecraft.banner.diagonal_left.black": "Triángulu cimeru a manzorga en prieto",
  "block.minecraft.banner.diagonal_left.blue": "Triángulu cimeru a manzorga n'azul",
  "block.minecraft.banner.diagonal_left.brown": "Triángulu cimeru a manzorga en marrón",
  "block.minecraft.banner.diagonal_left.cyan": "Triángulu cimeru a manzorga en ciano",
  "block.minecraft.banner.diagonal_left.gray": "Triángulu cimeru a manzorga en buxo",
  "block.minecraft.banner.diagonal_left.green": "Triángulu cimeru a manzorga en verde",
  "block.minecraft.banner.diagonal_left.light_blue": "Triángulu cimeru a manzorga n'azul claro",
  "block.minecraft.banner.diagonal_left.light_gray": "Triángulu cimeru a manzorga en buxo claro",
  "block.minecraft.banner.diagonal_left.lime": "Triángulu cimeru a manzorga en llima",
  "block.minecraft.banner.diagonal_left.magenta": "Triángulu cimeru a manzorga en maxenta",
  "block.minecraft.banner.diagonal_left.orange": "Triángulu cimeru a manzorga en naranxa",
  "block.minecraft.banner.diagonal_left.pink": "Triángulu cimeru a manzorga en rosa",
  "block.minecraft.banner.diagonal_left.purple": "Triángulu cimeru a manzorga en morao",
  "block.minecraft.banner.diagonal_left.red": "Triángulu cimeru a manzorga en colorao",
  "block.minecraft.banner.diagonal_left.white": "Triángulu cimeru a manzorga en blanco",
  "block.minecraft.banner.diagonal_left.yellow": "Triángulu cimeru a manzorga en mariello",
  "block.minecraft.banner.diagonal_right.black": "Triángulu cimeru a mandrecha en prieto",
  "block.minecraft.banner.diagonal_right.blue": "Triángulu cimeru a mandrecha n'azul",
  "block.minecraft.banner.diagonal_right.brown": "Triángulu cimeru a mandrecha en marrón",
  "block.minecraft.banner.diagonal_right.cyan": "Triángulu cimeru a mandrecha en ciano",
  "block.minecraft.banner.diagonal_right.gray": "Triángulu cimeru a mandrecha en buxo",
  "block.minecraft.banner.diagonal_right.green": "Triángulu cimeru a mandrecha en verde",
  "block.minecraft.banner.diagonal_right.light_blue": "Triángulu cimeru a mandrecha n'azul claro",
  "block.minecraft.banner.diagonal_right.light_gray": "Triángulu cimeru a mandrecha en buxo claro",
  "block.minecraft.banner.diagonal_right.lime": "Triángulu cimeru a mandrecha en llima",
  "block.minecraft.banner.diagonal_right.magenta": "Triángulu cimeru a mandrecha en maxenta",
  "block.minecraft.banner.diagonal_right.orange": "Triángulu cimeru a mandrecha en naranxa",
  "block.minecraft.banner.diagonal_right.pink": "Triángulu cimeru a mandrecha en rosa",
  "block.minecraft.banner.diagonal_right.purple": "Triángulu cimeru a mandrecha en morao",
  "block.minecraft.banner.diagonal_right.red": "Triángulu cimeru a mandrecha en colorao",
  "block.minecraft.banner.diagonal_right.white": "Triángulu cimeru a mandrecha en blanco",
  "block.minecraft.banner.diagonal_right.yellow": "Triángulu cimeru a mandrecha en mariello",
  "block.minecraft.banner.diagonal_up_left.black": "Triángulu baxeru a mandrecha en prieto",
  "block.minecraft.banner.diagonal_up_left.blue": "Triángulu baxeru a mandrecha n'azul",
  "block.minecraft.banner.diagonal_up_left.brown": "Triángulu baxeru a mandrecha en marrón",
  "block.minecraft.banner.diagonal_up_left.cyan": "Triángulu baxeru a mandrecha en ciano",
  "block.minecraft.banner.diagonal_up_left.gray": "Triángulu baxeru a mandrecha en buxo",
  "block.minecraft.banner.diagonal_up_left.green": "Triángulu baxeru a mandrecha en verde",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Triángulu baxeru a mandrecha n'azul claro",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Triángulu baxeru a mandrecha en buxo claro",
  "block.minecraft.banner.diagonal_up_left.lime": "Triángulu baxeru a mandrecha en llima",
  "block.minecraft.banner.diagonal_up_left.magenta": "Triángulu baxeru a mandrecha en maxenta",
  "block.minecraft.banner.diagonal_up_left.orange": "Triángulu baxeru a mandrecha en naranxa",
  "block.minecraft.banner.diagonal_up_left.pink": "Triángulu baxeru a mandrecha en rosa",
  "block.minecraft.banner.diagonal_up_left.purple": "Triángulu baxeru a mandrecha en morao",
  "block.minecraft.banner.diagonal_up_left.red": "Triángulu baxeru a mandrecha en colorao",
  "block.minecraft.banner.diagonal_up_left.white": "Triángulu baxeru a mandrecha en blanco",
  "block.minecraft.banner.diagonal_up_left.yellow": "Triángulu baxeru a mandrecha en mariello",
  "block.minecraft.banner.diagonal_up_right.black": "Triángulu baxeru a manzorga en prieto",
  "block.minecraft.banner.diagonal_up_right.blue": "Triángulu baxeru a manzorga n'azul",
  "block.minecraft.banner.diagonal_up_right.brown": "Triángulu baxeru a manzorga en marrón",
  "block.minecraft.banner.diagonal_up_right.cyan": "Triángulu baxeru a manzorga en ciano",
  "block.minecraft.banner.diagonal_up_right.gray": "Triángulu baxeru a manzorga en buxo",
  "block.minecraft.banner.diagonal_up_right.green": "Triángulu baxeru a manzorga en verde",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Triángulu baxeru a manzorga n'azul claro",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Triángulu baxeru a manzorga en buxo claro",
  "block.minecraft.banner.diagonal_up_right.lime": "Triángulu baxeru a manzorga en llima",
  "block.minecraft.banner.diagonal_up_right.magenta": "Triángulu baxeru a manzorga en maxenta",
  "block.minecraft.banner.diagonal_up_right.orange": "Triángulu baxeru a manzorga en naranxa",
  "block.minecraft.banner.diagonal_up_right.pink": "Triángulu baxeru a manzorga en rosa",
  "block.minecraft.banner.diagonal_up_right.purple": "Triángulu baxeru a manzorga en morao",
  "block.minecraft.banner.diagonal_up_right.red": "Triángulu baxeru a manzorga en colorao",
  "block.minecraft.banner.diagonal_up_right.white": "Triángulu baxeru a manzorga en blanco",
  "block.minecraft.banner.diagonal_up_right.yellow": "Triángulu baxeru a manzorga en mariello",
  "block.minecraft.banner.flow.black": "Fluyíu negru",
  "block.minecraft.banner.flow.blue": "Fluyíu azul",
  "block.minecraft.banner.flow.brown": "Fluyíu marrón",
  "block.minecraft.banner.flow.cyan": "Fluyíu cian",
  "block.minecraft.banner.flow.gray": "Fluyíu gris",
  "block.minecraft.banner.flow.green": "Fluyíu verde",
  "block.minecraft.banner.flow.light_blue": "Fluyíu azul claro",
  "block.minecraft.banner.flow.light_gray": "Fluyíu gris claro",
  "block.minecraft.banner.flow.lime": "Fluyíu lima",
  "block.minecraft.banner.flow.magenta": "Fluyíu magenta",
  "block.minecraft.banner.flow.orange": "Fluyíu naranja",
  "block.minecraft.banner.flow.pink": "Fluyíu rosa",
  "block.minecraft.banner.flow.purple": "Fluyíu púrpura",
  "block.minecraft.banner.flow.red": "Fluyíu rojo",
  "block.minecraft.banner.flow.white": "Fluyíu blanco",
  "block.minecraft.banner.flow.yellow": "Fluyíu amarillo",
  "block.minecraft.banner.flower.black": "Flor prieta",
  "block.minecraft.banner.flower.blue": "Flor azul",
  "block.minecraft.banner.flower.brown": "Flor marrón",
  "block.minecraft.banner.flower.cyan": "Flor ciana",
  "block.minecraft.banner.flower.gray": "Flor buxa",
  "block.minecraft.banner.flower.green": "Flor verde",
  "block.minecraft.banner.flower.light_blue": "Flor azul clara",
  "block.minecraft.banner.flower.light_gray": "Flor buxa clara",
  "block.minecraft.banner.flower.lime": "Flor llima",
  "block.minecraft.banner.flower.magenta": "Flor maxenta",
  "block.minecraft.banner.flower.orange": "Flor naranxa",
  "block.minecraft.banner.flower.pink": "Flor rosa",
  "block.minecraft.banner.flower.purple": "Flor morada",
  "block.minecraft.banner.flower.red": "Flor colorada",
  "block.minecraft.banner.flower.white": "Flor blanca",
  "block.minecraft.banner.flower.yellow": "Flor mariella",
  "block.minecraft.banner.globe.black": "Planeta prietu",
  "block.minecraft.banner.globe.blue": "Planeta azul",
  "block.minecraft.banner.globe.brown": "Planeta marrón",
  "block.minecraft.banner.globe.cyan": "Planeta cianu",
  "block.minecraft.banner.globe.gray": "Planeta buxu",
  "block.minecraft.banner.globe.green": "Planeta verde",
  "block.minecraft.banner.globe.light_blue": "Planeta azul claru",
  "block.minecraft.banner.globe.light_gray": "Planeta buxa clara",
  "block.minecraft.banner.globe.lime": "Planeta llima",
  "block.minecraft.banner.globe.magenta": "Planeta maxenta",
  "block.minecraft.banner.globe.orange": "Planeta naranxa",
  "block.minecraft.banner.globe.pink": "Planeta rosa",
  "block.minecraft.banner.globe.purple": "Planeta moráu",
  "block.minecraft.banner.globe.red": "Planeta coloráu",
  "block.minecraft.banner.globe.white": "Planeta blancu",
  "block.minecraft.banner.globe.yellow": "Planeta mariellu",
  "block.minecraft.banner.gradient.black": "Dilíu prietu dende lo cimero",
  "block.minecraft.banner.gradient.blue": "Dilíu azul dende lo cimero",
  "block.minecraft.banner.gradient.brown": "Dilíu marrón dende lo cimero",
  "block.minecraft.banner.gradient.cyan": "Dilíu cianu dende lo cimero",
  "block.minecraft.banner.gradient.gray": "Dilíu buxu dende lo cimero",
  "block.minecraft.banner.gradient.green": "Dilíu verde dende lo cimero",
  "block.minecraft.banner.gradient.light_blue": "Dilíu azul claro dende lo cimero",
  "block.minecraft.banner.gradient.light_gray": "Dilíu buxu claru dende lo cimero",
  "block.minecraft.banner.gradient.lime": "Dilíu llima dende lo cimero",
  "block.minecraft.banner.gradient.magenta": "Dilíu maxenta dende lo cimero",
  "block.minecraft.banner.gradient.orange": "Dilíu naranxa dende lo cimero",
  "block.minecraft.banner.gradient.pink": "Dilíu rosa dende lo cimero",
  "block.minecraft.banner.gradient.purple": "Dilíu moráu dende lo cimero",
  "block.minecraft.banner.gradient.red": "Dilíu coloráu dende lo cimero",
  "block.minecraft.banner.gradient.white": "Dilíu blancu dende lo cimero",
  "block.minecraft.banner.gradient.yellow": "Dilíu mariellu dende lo cimero",
  "block.minecraft.banner.gradient_up.black": "Dilíu prietu dende lo baxero",
  "block.minecraft.banner.gradient_up.blue": "Dilíu azul dende lo baxero",
  "block.minecraft.banner.gradient_up.brown": "Dilíu marrón dende lo baxero",
  "block.minecraft.banner.gradient_up.cyan": "Dilíu cian dende lo baxero",
  "block.minecraft.banner.gradient_up.gray": "Dilíu buxu dende lo baxero",
  "block.minecraft.banner.gradient_up.green": "Dilíu verde dende lo baxero",
  "block.minecraft.banner.gradient_up.light_blue": "Dilíu azul claro dende lo baxero",
  "block.minecraft.banner.gradient_up.light_gray": "Dilíu buxu claru dende lo baxero",
  "block.minecraft.banner.gradient_up.lime": "Dilíu llima dende lo baxero",
  "block.minecraft.banner.gradient_up.magenta": "Dilíu maxenta dende lo baxero",
  "block.minecraft.banner.gradient_up.orange": "Dilíu naranxa dende lo baxero",
  "block.minecraft.banner.gradient_up.pink": "Dilíu rosa dende lo baxero",
  "block.minecraft.banner.gradient_up.purple": "Dilíu moráu dende lo baxero",
  "block.minecraft.banner.gradient_up.red": "Dilíu coloráu dende lo baxero",
  "block.minecraft.banner.gradient_up.white": "Dilíu blancu dende lo baxero",
  "block.minecraft.banner.gradient_up.yellow": "Dilíu mariellu dende lo baxero",
  "block.minecraft.banner.guster.black": "Rafagón negro",
  "block.minecraft.banner.guster.blue": "Estampáu azul de breeze",
  "block.minecraft.banner.guster.brown": "Estampáu marrón de breeze",
  "block.minecraft.banner.guster.cyan": "Estampáu cian de breeze",
  "block.minecraft.banner.guster.gray": "Estampáu gris de breeze",
  "block.minecraft.banner.guster.green": "Estampáu verde de breeze",
  "block.minecraft.banner.guster.light_blue": "Estampáu azul claro de breeze",
  "block.minecraft.banner.guster.light_gray": "Estampáu gris claro de breeze",
  "block.minecraft.banner.guster.lime": "Estampáu llima de breeze",
  "block.minecraft.banner.guster.magenta": "Estampáu magenta de breeze",
  "block.minecraft.banner.guster.orange": "Estampáu naranxa de breeze",
  "block.minecraft.banner.guster.pink": "Estampáu rosa de breeze",
  "block.minecraft.banner.guster.purple": "Estampáu moráu de breeze",
  "block.minecraft.banner.guster.red": "Estampáu colloráu de breeze",
  "block.minecraft.banner.guster.white": "Estampáu blancu de breeze",
  "block.minecraft.banner.guster.yellow": "Estampáu mariellu de breeze",
  "block.minecraft.banner.half_horizontal.black": "Metá cimera en prieto",
  "block.minecraft.banner.half_horizontal.blue": "Metá cimera n'azul",
  "block.minecraft.banner.half_horizontal.brown": "Metá cimera en marrón",
  "block.minecraft.banner.half_horizontal.cyan": "Metá cimera en ciano",
  "block.minecraft.banner.half_horizontal.gray": "Metá cimera en buxo",
  "block.minecraft.banner.half_horizontal.green": "Metá cimera en verde",
  "block.minecraft.banner.half_horizontal.light_blue": "Metá cimera n'azul claro",
  "block.minecraft.banner.half_horizontal.light_gray": "Metá cimera en buxo claro",
  "block.minecraft.banner.half_horizontal.lime": "Metá cimera en llima",
  "block.minecraft.banner.half_horizontal.magenta": "Metá cimera en maxenta",
  "block.minecraft.banner.half_horizontal.orange": "Metá cimera en naranxa",
  "block.minecraft.banner.half_horizontal.pink": "Metá cimera en rosa",
  "block.minecraft.banner.half_horizontal.purple": "Metá cimera en moráu",
  "block.minecraft.banner.half_horizontal.red": "Metá cimera en colorao",
  "block.minecraft.banner.half_horizontal.white": "Metá cimera en blanco",
  "block.minecraft.banner.half_horizontal.yellow": "Metá cimera en mariello",
  "block.minecraft.banner.half_horizontal_bottom.black": "Metá baxera en prieto",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Metá baxera n'azul",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Metá baxera en marrón",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Metá baxera en ciano",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Metá baxera en buxo",
  "block.minecraft.banner.half_horizontal_bottom.green": "Metá baxera en verde",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Metá baxera n'azul claro",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Metá baxera en buxo claro",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Metá baxera en llima",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Metá baxera en maxenta",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Metá baxera en naranxa",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Metá baxera en rosa",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Metá baxera en morao",
  "block.minecraft.banner.half_horizontal_bottom.red": "Metá baxera en colorao",
  "block.minecraft.banner.half_horizontal_bottom.white": "Metá baxera en blanco",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Metá baxera en mariello",
  "block.minecraft.banner.half_vertical.black": "Metá a manzorga en prieto",
  "block.minecraft.banner.half_vertical.blue": "Metá a manzorga n'azul",
  "block.minecraft.banner.half_vertical.brown": "Metá a manzorga en marrón",
  "block.minecraft.banner.half_vertical.cyan": "Metá a manzorga en ciano",
  "block.minecraft.banner.half_vertical.gray": "Metá a manzorga en buxo",
  "block.minecraft.banner.half_vertical.green": "Metá a manzorga en verde",
  "block.minecraft.banner.half_vertical.light_blue": "Metá a manzorga n'azul claro",
  "block.minecraft.banner.half_vertical.light_gray": "Metá a manzorga en buxu claro",
  "block.minecraft.banner.half_vertical.lime": "Metá a manzorga en llima",
  "block.minecraft.banner.half_vertical.magenta": "Metá a manzorga en maxenta",
  "block.minecraft.banner.half_vertical.orange": "Metá a manzorga en naranxa",
  "block.minecraft.banner.half_vertical.pink": "Metá a manzorga en rosa",
  "block.minecraft.banner.half_vertical.purple": "Metá a manzorga en moráu",
  "block.minecraft.banner.half_vertical.red": "Metá a manzorga en colorao",
  "block.minecraft.banner.half_vertical.white": "Metá a manzorga en blanco",
  "block.minecraft.banner.half_vertical.yellow": "Metá a manzorga en mariello",
  "block.minecraft.banner.half_vertical_right.black": "Metá a mandrecha en prieto",
  "block.minecraft.banner.half_vertical_right.blue": "Metá a mandrecha n'azul",
  "block.minecraft.banner.half_vertical_right.brown": "Metá a mandrecha en marrón",
  "block.minecraft.banner.half_vertical_right.cyan": "Metá a mandrecha en ciano",
  "block.minecraft.banner.half_vertical_right.gray": "Metá a mandrecha en buxo",
  "block.minecraft.banner.half_vertical_right.green": "Metá a mandrecha en verde",
  "block.minecraft.banner.half_vertical_right.light_blue": "Metá a mandrecha n'azul claro",
  "block.minecraft.banner.half_vertical_right.light_gray": "Metá a mandrecha en buxo claro",
  "block.minecraft.banner.half_vertical_right.lime": "Metá a mandrecha en llima",
  "block.minecraft.banner.half_vertical_right.magenta": "Metá a mandrecha en maxenta",
  "block.minecraft.banner.half_vertical_right.orange": "Metá a mandrecha en naranxa",
  "block.minecraft.banner.half_vertical_right.pink": "Metá a mandrecha en rosa",
  "block.minecraft.banner.half_vertical_right.purple": "Metá a mandrecha en morao",
  "block.minecraft.banner.half_vertical_right.red": "Metá a mandrecha en colorao",
  "block.minecraft.banner.half_vertical_right.white": "Metá a mandrecha en blanco",
  "block.minecraft.banner.half_vertical_right.yellow": "Metá a mandrecha en mariello",
  "block.minecraft.banner.mojang.black": "Llogotipu prietu",
  "block.minecraft.banner.mojang.blue": "Llogotipu azul",
  "block.minecraft.banner.mojang.brown": "Llogotipu marrón",
  "block.minecraft.banner.mojang.cyan": "Llogotipu cianu",
  "block.minecraft.banner.mojang.gray": "Llogotipu buxu",
  "block.minecraft.banner.mojang.green": "Llogotipu verde",
  "block.minecraft.banner.mojang.light_blue": "Llogotipu azul claro",
  "block.minecraft.banner.mojang.light_gray": "Llogotipu buxu claro",
  "block.minecraft.banner.mojang.lime": "Llogotipu llima",
  "block.minecraft.banner.mojang.magenta": "Llogotipu maxenta",
  "block.minecraft.banner.mojang.orange": "Llogotipu naranxa",
  "block.minecraft.banner.mojang.pink": "Llogotipu rosa",
  "block.minecraft.banner.mojang.purple": "Llogotipu moráu",
  "block.minecraft.banner.mojang.red": "Llogotipu coloráu",
  "block.minecraft.banner.mojang.white": "Llogotipu blancu",
  "block.minecraft.banner.mojang.yellow": "Llogotipu mariellu",
  "block.minecraft.banner.piglin.black": "Focicu prietu",
  "block.minecraft.banner.piglin.blue": "Focicu azul",
  "block.minecraft.banner.piglin.brown": "Focicu marrón",
  "block.minecraft.banner.piglin.cyan": "Focicu cianu",
  "block.minecraft.banner.piglin.gray": "Focu buxu",
  "block.minecraft.banner.piglin.green": "Focicu verde",
  "block.minecraft.banner.piglin.light_blue": "Focicu azul claru",
  "block.minecraft.banner.piglin.light_gray": "Focicu gris claru",
  "block.minecraft.banner.piglin.lime": "Focicu llima",
  "block.minecraft.banner.piglin.magenta": "Focicu maxenta",
  "block.minecraft.banner.piglin.orange": "Focicu naranxa",
  "block.minecraft.banner.piglin.pink": "Focicu rosa",
  "block.minecraft.banner.piglin.purple": "Focicu moráu",
  "block.minecraft.banner.piglin.red": "Focicu coloráu",
  "block.minecraft.banner.piglin.white": "Focicu blancu",
  "block.minecraft.banner.piglin.yellow": "Focicu mariellu",
  "block.minecraft.banner.rhombus.black": "Rombu prietu",
  "block.minecraft.banner.rhombus.blue": "Rombu azul",
  "block.minecraft.banner.rhombus.brown": "Rombu marrón",
  "block.minecraft.banner.rhombus.cyan": "Rombu cianu",
  "block.minecraft.banner.rhombus.gray": "Rombu buxu",
  "block.minecraft.banner.rhombus.green": "Rombu verde",
  "block.minecraft.banner.rhombus.light_blue": "Rombu azul claru",
  "block.minecraft.banner.rhombus.light_gray": "Rombu buxu claro",
  "block.minecraft.banner.rhombus.lime": "Rombu llima",
  "block.minecraft.banner.rhombus.magenta": "Rombu maxenta",
  "block.minecraft.banner.rhombus.orange": "Rombu naranxa",
  "block.minecraft.banner.rhombus.pink": "Rombu rosa",
  "block.minecraft.banner.rhombus.purple": "Rombu moráu",
  "block.minecraft.banner.rhombus.red": "Rombu coloráu",
  "block.minecraft.banner.rhombus.white": "Rombu blancu",
  "block.minecraft.banner.rhombus.yellow": "Rombu mariellu",
  "block.minecraft.banner.skull.black": "Craniu prietu",
  "block.minecraft.banner.skull.blue": "Craniu azul",
  "block.minecraft.banner.skull.brown": "Craniu marrón",
  "block.minecraft.banner.skull.cyan": "Craniu cianu",
  "block.minecraft.banner.skull.gray": "Craniu buxu",
  "block.minecraft.banner.skull.green": "Craniu verde",
  "block.minecraft.banner.skull.light_blue": "Craniu azul claru",
  "block.minecraft.banner.skull.light_gray": "Craniu buxu claru",
  "block.minecraft.banner.skull.lime": "Craniu llima",
  "block.minecraft.banner.skull.magenta": "Craniu maxenta",
  "block.minecraft.banner.skull.orange": "Craniu naranxa",
  "block.minecraft.banner.skull.pink": "Craniu rosa",
  "block.minecraft.banner.skull.purple": "Craniu moráu",
  "block.minecraft.banner.skull.red": "Craniu coloráu",
  "block.minecraft.banner.skull.white": "Craniu blancu",
  "block.minecraft.banner.skull.yellow": "Craniu mariellu",
  "block.minecraft.banner.small_stripes.black": "Rayáu con faces en prieto",
  "block.minecraft.banner.small_stripes.blue": "Rayáu con faces n'azul",
  "block.minecraft.banner.small_stripes.brown": "Rayáu con faces en marrón",
  "block.minecraft.banner.small_stripes.cyan": "Rayáu con faces en ciano",
  "block.minecraft.banner.small_stripes.gray": "Rayáu con faces en buxo",
  "block.minecraft.banner.small_stripes.green": "Rayáu con faces en verde",
  "block.minecraft.banner.small_stripes.light_blue": "Rayáu con faces n'azul claro",
  "block.minecraft.banner.small_stripes.light_gray": "Rayáu con faces en buxo claro",
  "block.minecraft.banner.small_stripes.lime": "Rayáu con faces en llima",
  "block.minecraft.banner.small_stripes.magenta": "Rayáu con faces en maxenta",
  "block.minecraft.banner.small_stripes.orange": "Rayáu con faces en naranxa",
  "block.minecraft.banner.small_stripes.pink": "Rayáu con faces en rosa",
  "block.minecraft.banner.small_stripes.purple": "Rayáu con faces en morao",
  "block.minecraft.banner.small_stripes.red": "Rayáu con faces en colorao",
  "block.minecraft.banner.small_stripes.white": "Rayáu con faces en blanco",
  "block.minecraft.banner.small_stripes.yellow": "Rayáu con faces en mariello",
  "block.minecraft.banner.square_bottom_left.black": "Cuadráu baxeru a mandrecha en prieto",
  "block.minecraft.banner.square_bottom_left.blue": "Cuadráu baxeru a mandrecha n'azul",
  "block.minecraft.banner.square_bottom_left.brown": "Cuadráu baxeru a mandrecha en marrón",
  "block.minecraft.banner.square_bottom_left.cyan": "Cuadráu baxeru a mandrecha en ciano",
  "block.minecraft.banner.square_bottom_left.gray": "Cuadráu baxeru a mandrecha en buxo",
  "block.minecraft.banner.square_bottom_left.green": "Cuadráu baxeru a mandrecha en verde",
  "block.minecraft.banner.square_bottom_left.light_blue": "Cuadráu baxeru a mandrecha n'azul claro",
  "block.minecraft.banner.square_bottom_left.light_gray": "Cuadráu baxeru a mandrecha en buxo claro",
  "block.minecraft.banner.square_bottom_left.lime": "Cuadráu baxeru a mandrecha en llima",
  "block.minecraft.banner.square_bottom_left.magenta": "Cuadráu baxeru a mandrecha en maxenta",
  "block.minecraft.banner.square_bottom_left.orange": "Cuadráu baxeru a mandrecha en naranxa",
  "block.minecraft.banner.square_bottom_left.pink": "Cuadráu baxeru a mandrecha en rosa",
  "block.minecraft.banner.square_bottom_left.purple": "Cuadráu baxeru a mandrecha en morao",
  "block.minecraft.banner.square_bottom_left.red": "Cuadráu baxeru a mandrecha en colorao",
  "block.minecraft.banner.square_bottom_left.white": "Cuadráu baxeru a mandrecha en blanco",
  "block.minecraft.banner.square_bottom_left.yellow": "Cuadráu baxeru a mandrecha en mariello",
  "block.minecraft.banner.square_bottom_right.black": "Cuadráu baxeru a manzorga en prieto",
  "block.minecraft.banner.square_bottom_right.blue": "Cuadráu baxeru a manzorga n'azul",
  "block.minecraft.banner.square_bottom_right.brown": "Cuadráu baxeru a manzorga en marrón",
  "block.minecraft.banner.square_bottom_right.cyan": "Cuadráu baxeru a manzorga en ciano",
  "block.minecraft.banner.square_bottom_right.gray": "Cuadráu baxeru a manzorga en buxo",
  "block.minecraft.banner.square_bottom_right.green": "Cuadráu baxeru a manzorga en verde",
  "block.minecraft.banner.square_bottom_right.light_blue": "Cuadráu baxeru a manzorga n'azul claro",
  "block.minecraft.banner.square_bottom_right.light_gray": "Cuadráu baxeru a manzorga en buxo claro",
  "block.minecraft.banner.square_bottom_right.lime": "Cuadráu baxeru a manzorga en llima",
  "block.minecraft.banner.square_bottom_right.magenta": "Cuadráu baxeru a manzorga en maxenta",
  "block.minecraft.banner.square_bottom_right.orange": "Cuadráu baxeru a manzorga en naranxa",
  "block.minecraft.banner.square_bottom_right.pink": "Cuadráu baxeru a manzorga en rosa",
  "block.minecraft.banner.square_bottom_right.purple": "Cuadráu baxeru a manzorga en morao",
  "block.minecraft.banner.square_bottom_right.red": "Cuadráu baxeru a manzorga en colorao",
  "block.minecraft.banner.square_bottom_right.white": "Cuadráu baxeru a manzorga en blanco",
  "block.minecraft.banner.square_bottom_right.yellow": "Cuadráu baxeru a manzorga en mariello",
  "block.minecraft.banner.square_top_left.black": "Cuadráu cimeru a mandrecha en prieto",
  "block.minecraft.banner.square_top_left.blue": "Cuadráu cimeru a mandrecha n'azul",
  "block.minecraft.banner.square_top_left.brown": "Cuadráu cimeru a mandrecha en marrón",
  "block.minecraft.banner.square_top_left.cyan": "Cuadráu cimeru a mandrecha en ciano",
  "block.minecraft.banner.square_top_left.gray": "Cuadráu cimeru a mandrecha en buxo",
  "block.minecraft.banner.square_top_left.green": "Cuadráu cimeru a mandrecha en verde",
  "block.minecraft.banner.square_top_left.light_blue": "Cuadráu cimeru a mandrecha n'azul claro",
  "block.minecraft.banner.square_top_left.light_gray": "Cuadráu cimeru a mandrecha en buxo claro",
  "block.minecraft.banner.square_top_left.lime": "Cuadráu cimeru a mandrecha en llima",
  "block.minecraft.banner.square_top_left.magenta": "Cuadráu cimeru a mandrecha en maxenta",
  "block.minecraft.banner.square_top_left.orange": "Cuadráu cimeru a mandrecha en naranxa",
  "block.minecraft.banner.square_top_left.pink": "Cuadráu cimeru a mandrecha en rosa",
  "block.minecraft.banner.square_top_left.purple": "Cuadráu cimeru a mandrecha en morao",
  "block.minecraft.banner.square_top_left.red": "Cuadráu cimeru a mandrecha en colorao",
  "block.minecraft.banner.square_top_left.white": "Cuadráu cimeru a mandrecha en blanco",
  "block.minecraft.banner.square_top_left.yellow": "Cuadráu cimeru a mandrecha en mariello",
  "block.minecraft.banner.square_top_right.black": "Cuadráu cimeru a manzorga en prieto",
  "block.minecraft.banner.square_top_right.blue": "Cuadráu cimeru a manzorga n'azul",
  "block.minecraft.banner.square_top_right.brown": "Cuadráu cimeru a manzorga en marrón",
  "block.minecraft.banner.square_top_right.cyan": "Cuadráu cimeru a manzorga en ciano",
  "block.minecraft.banner.square_top_right.gray": "Cuadráu cimeru a manzorga en buxo",
  "block.minecraft.banner.square_top_right.green": "Cuadráu cimeru a manzorga en verde",
  "block.minecraft.banner.square_top_right.light_blue": "Cuadráu cimeru a manzorga n'azul claro",
  "block.minecraft.banner.square_top_right.light_gray": "Cuadráu cimeru a manzorga en buxo claro",
  "block.minecraft.banner.square_top_right.lime": "Cuadráu cimeru a manzorga en llima",
  "block.minecraft.banner.square_top_right.magenta": "Cuadráu cimeru a manzorga en maxenta",
  "block.minecraft.banner.square_top_right.orange": "Cuadráu cimeru a manzorga en naranxa",
  "block.minecraft.banner.square_top_right.pink": "Cuadráu cimeru a manzorga en rosa",
  "block.minecraft.banner.square_top_right.purple": "Cuadráu cimeru a manzorga en morao",
  "block.minecraft.banner.square_top_right.red": "Cuadráu cimeru a manzorga en colorao",
  "block.minecraft.banner.square_top_right.white": "Cuadráu cimeru a manzorga en blanco",
  "block.minecraft.banner.square_top_right.yellow": "Cuadráu cimeru a manzorga en mariello",
  "block.minecraft.banner.straight_cross.black": "Cruz prieta",
  "block.minecraft.banner.straight_cross.blue": "Cruz azul",
  "block.minecraft.banner.straight_cross.brown": "Cruz marrón",
  "block.minecraft.banner.straight_cross.cyan": "Cruz ciana",
  "block.minecraft.banner.straight_cross.gray": "Cruz buxa",
  "block.minecraft.banner.straight_cross.green": "Cruz verde",
  "block.minecraft.banner.straight_cross.light_blue": "Cruz azul clara",
  "block.minecraft.banner.straight_cross.light_gray": "Cruz buxa claro",
  "block.minecraft.banner.straight_cross.lime": "Cruz llima",
  "block.minecraft.banner.straight_cross.magenta": "Cruz maxenta",
  "block.minecraft.banner.straight_cross.orange": "Cruz naranxa",
  "block.minecraft.banner.straight_cross.pink": "Cruz rosa",
  "block.minecraft.banner.straight_cross.purple": "Cruz morada",
  "block.minecraft.banner.straight_cross.red": "Cruz colorada",
  "block.minecraft.banner.straight_cross.white": "Cruz blanca",
  "block.minecraft.banner.straight_cross.yellow": "Cruz mariella",
  "block.minecraft.banner.stripe_bottom.black": "Base prieta",
  "block.minecraft.banner.stripe_bottom.blue": "Base azul",
  "block.minecraft.banner.stripe_bottom.brown": "Base marrón",
  "block.minecraft.banner.stripe_bottom.cyan": "Base ciana",
  "block.minecraft.banner.stripe_bottom.gray": "Base buxa",
  "block.minecraft.banner.stripe_bottom.green": "Base verde",
  "block.minecraft.banner.stripe_bottom.light_blue": "Base azul claro",
  "block.minecraft.banner.stripe_bottom.light_gray": "Base buxa claro",
  "block.minecraft.banner.stripe_bottom.lime": "Base llima",
  "block.minecraft.banner.stripe_bottom.magenta": "Base maxenta",
  "block.minecraft.banner.stripe_bottom.orange": "Base naranxa",
  "block.minecraft.banner.stripe_bottom.pink": "Base rosa",
  "block.minecraft.banner.stripe_bottom.purple": "Base morada",
  "block.minecraft.banner.stripe_bottom.red": "Base colorada",
  "block.minecraft.banner.stripe_bottom.white": "Base blanca",
  "block.minecraft.banner.stripe_bottom.yellow": "Base mariella",
  "block.minecraft.banner.stripe_center.black": "Faza prieta central",
  "block.minecraft.banner.stripe_center.blue": "Faza azul central",
  "block.minecraft.banner.stripe_center.brown": "Faza marrón central",
  "block.minecraft.banner.stripe_center.cyan": "Faza ciana central",
  "block.minecraft.banner.stripe_center.gray": "Faza buxa central",
  "block.minecraft.banner.stripe_center.green": "Faza verde central",
  "block.minecraft.banner.stripe_center.light_blue": "Faza azul clara central",
  "block.minecraft.banner.stripe_center.light_gray": "Faza buxa clara central",
  "block.minecraft.banner.stripe_center.lime": "Faza llima central",
  "block.minecraft.banner.stripe_center.magenta": "Faza maxenta central",
  "block.minecraft.banner.stripe_center.orange": "Faza naranxa central",
  "block.minecraft.banner.stripe_center.pink": "Faza rosa central",
  "block.minecraft.banner.stripe_center.purple": "Faza morada central",
  "block.minecraft.banner.stripe_center.red": "Faza colorada central",
  "block.minecraft.banner.stripe_center.white": "Faza blanca central",
  "block.minecraft.banner.stripe_center.yellow": "Faza mariella central",
  "block.minecraft.banner.stripe_downleft.black": "Llinia cruciada a manzorga en prieto",
  "block.minecraft.banner.stripe_downleft.blue": "Llinia cruciada a manzorga n'azul",
  "block.minecraft.banner.stripe_downleft.brown": "Llinia cruciada a manzorga en marrón",
  "block.minecraft.banner.stripe_downleft.cyan": "Llinia cruciada a manzorga en ciano",
  "block.minecraft.banner.stripe_downleft.gray": "Llinia cruciada a manzorga en buxo",
  "block.minecraft.banner.stripe_downleft.green": "Llinia cruciada a manzorga en verde",
  "block.minecraft.banner.stripe_downleft.light_blue": "Llinia cruciada a manzorga n'azul claro",
  "block.minecraft.banner.stripe_downleft.light_gray": "Llinia cruciada a manzorga en buxo claro",
  "block.minecraft.banner.stripe_downleft.lime": "Llinia cruciada a manzorga en llima",
  "block.minecraft.banner.stripe_downleft.magenta": "Llinia cruciada a manzorga en maxenta",
  "block.minecraft.banner.stripe_downleft.orange": "Llinia cruciada a manzorga en naranxa",
  "block.minecraft.banner.stripe_downleft.pink": "Llinia cruciada a manzorga en rosa",
  "block.minecraft.banner.stripe_downleft.purple": "Llinia cruciada a manzorga en morao",
  "block.minecraft.banner.stripe_downleft.red": "Llinia cruciada a manzorga en colorao",
  "block.minecraft.banner.stripe_downleft.white": "Llinia cruciada a manzorga en blanco",
  "block.minecraft.banner.stripe_downleft.yellow": "Llinia cruciada a manzorga en mariello",
  "block.minecraft.banner.stripe_downright.black": "Llinia cruciada en prieto",
  "block.minecraft.banner.stripe_downright.blue": "Llinia cruciada n'azul",
  "block.minecraft.banner.stripe_downright.brown": "Llinia cruciada en marrón",
  "block.minecraft.banner.stripe_downright.cyan": "Llinia cruciada en ciano",
  "block.minecraft.banner.stripe_downright.gray": "Llinia cruciada en buxo",
  "block.minecraft.banner.stripe_downright.green": "Llinia cruciada en verde",
  "block.minecraft.banner.stripe_downright.light_blue": "Llinia cruciada n'azul claro",
  "block.minecraft.banner.stripe_downright.light_gray": "Llinia cruciada en buxo claro",
  "block.minecraft.banner.stripe_downright.lime": "Llinia cruciada en llima",
  "block.minecraft.banner.stripe_downright.magenta": "Llinia cruciada en maxenta",
  "block.minecraft.banner.stripe_downright.orange": "Llinia cruciada en naranxa",
  "block.minecraft.banner.stripe_downright.pink": "Llinia cruciada en rosa",
  "block.minecraft.banner.stripe_downright.purple": "Llinia cruciada en morao",
  "block.minecraft.banner.stripe_downright.red": "Llinia cruciada en colorao",
  "block.minecraft.banner.stripe_downright.white": "Llinia cruciada en blanco",
  "block.minecraft.banner.stripe_downright.yellow": "Llinia cruciada en mariello",
  "block.minecraft.banner.stripe_left.black": "Faza prieta a mandrecha",
  "block.minecraft.banner.stripe_left.blue": "Faza azul a mandrecha",
  "block.minecraft.banner.stripe_left.brown": "Faza marrón a mandrecha",
  "block.minecraft.banner.stripe_left.cyan": "Faza ciana a mandrecha",
  "block.minecraft.banner.stripe_left.gray": "Faza buxa a mandrecha",
  "block.minecraft.banner.stripe_left.green": "Faza verde a mandrecha",
  "block.minecraft.banner.stripe_left.light_blue": "Faza azul clara a mandrecha",
  "block.minecraft.banner.stripe_left.light_gray": "Faza buxa clara a mandrecha",
  "block.minecraft.banner.stripe_left.lime": "Faza llima a mandrecha",
  "block.minecraft.banner.stripe_left.magenta": "Faza maxenta a mandrecha",
  "block.minecraft.banner.stripe_left.orange": "Faza naranxa a mandrecha",
  "block.minecraft.banner.stripe_left.pink": "Faza rosa a mandrecha",
  "block.minecraft.banner.stripe_left.purple": "Faza morada a mandrecha",
  "block.minecraft.banner.stripe_left.red": "Faza colorada a mandrecha",
  "block.minecraft.banner.stripe_left.white": "Faza blanca a mandrecha",
  "block.minecraft.banner.stripe_left.yellow": "Faza mariella a mandrecha",
  "block.minecraft.banner.stripe_middle.black": "Llinia prieta central",
  "block.minecraft.banner.stripe_middle.blue": "Llinia azul central",
  "block.minecraft.banner.stripe_middle.brown": "Llinia marrón central",
  "block.minecraft.banner.stripe_middle.cyan": "Llinia ciana central",
  "block.minecraft.banner.stripe_middle.gray": "Llinia buxa central",
  "block.minecraft.banner.stripe_middle.green": "Llinia verde central",
  "block.minecraft.banner.stripe_middle.light_blue": "Llinia azul clara central",
  "block.minecraft.banner.stripe_middle.light_gray": "Llinia buxa clara central",
  "block.minecraft.banner.stripe_middle.lime": "Llinia llima central",
  "block.minecraft.banner.stripe_middle.magenta": "Llinia maxenta central",
  "block.minecraft.banner.stripe_middle.orange": "Llinia naranxa central",
  "block.minecraft.banner.stripe_middle.pink": "Llinia rosa central",
  "block.minecraft.banner.stripe_middle.purple": "Llinia morada central",
  "block.minecraft.banner.stripe_middle.red": "Llinia colorada central",
  "block.minecraft.banner.stripe_middle.white": "Llinia blanca central",
  "block.minecraft.banner.stripe_middle.yellow": "Llinia mariella central",
  "block.minecraft.banner.stripe_right.black": "Faza prieta a manzorga",
  "block.minecraft.banner.stripe_right.blue": "Faza azul a manzorga",
  "block.minecraft.banner.stripe_right.brown": "Faza marrón a manzorga",
  "block.minecraft.banner.stripe_right.cyan": "Faza ciana a manzorga",
  "block.minecraft.banner.stripe_right.gray": "Faza buxa a manzorga",
  "block.minecraft.banner.stripe_right.green": "Faza verde a manzorga",
  "block.minecraft.banner.stripe_right.light_blue": "Faza azul clara a manzorga",
  "block.minecraft.banner.stripe_right.light_gray": "Faza buxa clara a manzorga",
  "block.minecraft.banner.stripe_right.lime": "Faza llima a manzorga",
  "block.minecraft.banner.stripe_right.magenta": "Faza maxenta a manzorga",
  "block.minecraft.banner.stripe_right.orange": "Faza naranxa a manzorga",
  "block.minecraft.banner.stripe_right.pink": "Faza rosa a manzorga",
  "block.minecraft.banner.stripe_right.purple": "Faza morada a manzorga",
  "block.minecraft.banner.stripe_right.red": "Faza colorada a manzorga",
  "block.minecraft.banner.stripe_right.white": "Faza blanca a manzorga",
  "block.minecraft.banner.stripe_right.yellow": "Faza mariella a manzorga",
  "block.minecraft.banner.stripe_top.black": "Dentáu prietu",
  "block.minecraft.banner.stripe_top.blue": "Dentáu azul",
  "block.minecraft.banner.stripe_top.brown": "Dentáu marrón",
  "block.minecraft.banner.stripe_top.cyan": "Dentáu cianu",
  "block.minecraft.banner.stripe_top.gray": "Dentáu buxu",
  "block.minecraft.banner.stripe_top.green": "Dentáu verde",
  "block.minecraft.banner.stripe_top.light_blue": "Dentáu azul claro",
  "block.minecraft.banner.stripe_top.light_gray": "Dentáu buxu claro",
  "block.minecraft.banner.stripe_top.lime": "Dentáu llima",
  "block.minecraft.banner.stripe_top.magenta": "Dentáu maxenta",
  "block.minecraft.banner.stripe_top.orange": "Dentáu naranxa",
  "block.minecraft.banner.stripe_top.pink": "Dentáu rosa",
  "block.minecraft.banner.stripe_top.purple": "Dentáu moráu",
  "block.minecraft.banner.stripe_top.red": "Dentáu coloráu",
  "block.minecraft.banner.stripe_top.white": "Dentáu blancu",
  "block.minecraft.banner.stripe_top.yellow": "Dentáu mariellu",
  "block.minecraft.banner.triangle_bottom.black": "Chebrón prietu",
  "block.minecraft.banner.triangle_bottom.blue": "Chebrón azul",
  "block.minecraft.banner.triangle_bottom.brown": "Chebrón marrón",
  "block.minecraft.banner.triangle_bottom.cyan": "Chebrón cianu",
  "block.minecraft.banner.triangle_bottom.gray": "Chebrón buxu",
  "block.minecraft.banner.triangle_bottom.green": "Chebrón verde",
  "block.minecraft.banner.triangle_bottom.light_blue": "Chebrón azul claru",
  "block.minecraft.banner.triangle_bottom.light_gray": "Chebrón buxu claru",
  "block.minecraft.banner.triangle_bottom.lime": "Chebrón llima",
  "block.minecraft.banner.triangle_bottom.magenta": "Chebrón maxenta",
  "block.minecraft.banner.triangle_bottom.orange": "Chebrón naranxa",
  "block.minecraft.banner.triangle_bottom.pink": "Chebrón rosa",
  "block.minecraft.banner.triangle_bottom.purple": "Chebrón moráu",
  "block.minecraft.banner.triangle_bottom.red": "Chebrón coloráu",
  "block.minecraft.banner.triangle_bottom.white": "Chebrón blancu",
  "block.minecraft.banner.triangle_bottom.yellow": "Chebrón mariellu",
  "block.minecraft.banner.triangle_top.black": "Chebrón prietu cimeru",
  "block.minecraft.banner.triangle_top.blue": "Chebrón azul cimeru",
  "block.minecraft.banner.triangle_top.brown": "Chebrón marrón cimeru",
  "block.minecraft.banner.triangle_top.cyan": "Chebrón cian cimeru",
  "block.minecraft.banner.triangle_top.gray": "Chebrón buxu cimeru",
  "block.minecraft.banner.triangle_top.green": "Chebrón verde cimeru",
  "block.minecraft.banner.triangle_top.light_blue": "Chebrón azul claru cimeru",
  "block.minecraft.banner.triangle_top.light_gray": "Chebrón buxu claru cimeru",
  "block.minecraft.banner.triangle_top.lime": "Chebrón llima cimeru",
  "block.minecraft.banner.triangle_top.magenta": "Chebrón maxenta cimeru",
  "block.minecraft.banner.triangle_top.orange": "Chebrón naranxa cimeru",
  "block.minecraft.banner.triangle_top.pink": "Chebrón rosa cimeru",
  "block.minecraft.banner.triangle_top.purple": "Chebrón moráu cimeru",
  "block.minecraft.banner.triangle_top.red": "Chebrón coloráu cimeru",
  "block.minecraft.banner.triangle_top.white": "Chebrón blancu cimeru",
  "block.minecraft.banner.triangle_top.yellow": "Chebrón mariellu cimeru",
  "block.minecraft.banner.triangles_bottom.black": "Dentáu prietu baxeru",
  "block.minecraft.banner.triangles_bottom.blue": "Dentáu azul baxeru",
  "block.minecraft.banner.triangles_bottom.brown": "Dentáu marrón baxeru",
  "block.minecraft.banner.triangles_bottom.cyan": "Dentáu cian baxeru",
  "block.minecraft.banner.triangles_bottom.gray": "Dentáu buxu baxeru",
  "block.minecraft.banner.triangles_bottom.green": "Dentáu verde baxeru",
  "block.minecraft.banner.triangles_bottom.light_blue": "Dentáu azul claru baxeru",
  "block.minecraft.banner.triangles_bottom.light_gray": "Dentáu buxu claru baxeru",
  "block.minecraft.banner.triangles_bottom.lime": "Dentáu llima baxeru",
  "block.minecraft.banner.triangles_bottom.magenta": "Dentáu maxenta baxeru",
  "block.minecraft.banner.triangles_bottom.orange": "Dentáu naranxa baxeru",
  "block.minecraft.banner.triangles_bottom.pink": "Dentáu rosa baxeru",
  "block.minecraft.banner.triangles_bottom.purple": "Dentáu moráu baxeru",
  "block.minecraft.banner.triangles_bottom.red": "Dentáu coloráu baxeru",
  "block.minecraft.banner.triangles_bottom.white": "Dentáu blancu baxeru",
  "block.minecraft.banner.triangles_bottom.yellow": "Dentáu mariellu baxeru",
  "block.minecraft.banner.triangles_top.black": "Dentáu prietu cimeru",
  "block.minecraft.banner.triangles_top.blue": "Dentáu azul cimeru",
  "block.minecraft.banner.triangles_top.brown": "Dentáu marrón cimeru",
  "block.minecraft.banner.triangles_top.cyan": "Dentáu cian cimeru",
  "block.minecraft.banner.triangles_top.gray": "Dentáu buxu cimeru",
  "block.minecraft.banner.triangles_top.green": "Dentáu verde cimeru",
  "block.minecraft.banner.triangles_top.light_blue": "Dentáu azul claru cimeru",
  "block.minecraft.banner.triangles_top.light_gray": "Dentáu buxu claru cimeru",
  "block.minecraft.banner.triangles_top.lime": "Dentáu llima cimeru",
  "block.minecraft.banner.triangles_top.magenta": "Dentáu maxenta cimeru",
  "block.minecraft.banner.triangles_top.orange": "Dentáu naranxa cimeru",
  "block.minecraft.banner.triangles_top.pink": "Dentáu rosa cimeru",
  "block.minecraft.banner.triangles_top.purple": "Dentáu moráu cimeru",
  "block.minecraft.banner.triangles_top.red": "Dentáu coloráu cimeru",
  "block.minecraft.banner.triangles_top.white": "Dentáu blancu cimeru",
  "block.minecraft.banner.triangles_top.yellow": "Dentáu mariellu cimeru",
  "block.minecraft.barrel": "Barril",
  "block.minecraft.barrier": "Barrera",
  "block.minecraft.basalt": "Basaltu",
  "block.minecraft.beacon": "Baliza",
  "block.minecraft.beacon.primary": "Poder primariu",
  "block.minecraft.beacon.secondary": "Poder secundariu",
  "block.minecraft.bed.no_sleep": "Namás pues dormir pela nueche o demientres tempestaes llétriques",
  "block.minecraft.bed.not_safe": "Agora nun pues descansar, hai monstruos cierca",
  "block.minecraft.bed.obstructed": "La cama ta torgada",
  "block.minecraft.bed.occupied": "Esta cama ta ocupada",
  "block.minecraft.bed.too_far_away": "Agora nun pues descansar, la cama ta perlloñe",
  "block.minecraft.bedrock": "Piedra base",
  "block.minecraft.bee_nest": "Nial d'abeyes",
  "block.minecraft.beehive": "Colmena",
  "block.minecraft.beetroots": "Remolaches",
  "block.minecraft.bell": "Campana",
  "block.minecraft.big_dripleaf": "Plantaforma grande",
  "block.minecraft.big_dripleaf_stem": "Tallu de plantaforma grande",
  "block.minecraft.birch_button": "Botón de bidul",
  "block.minecraft.birch_door": "Puerta de bidul",
  "block.minecraft.birch_fence": "Valla de bidul",
  "block.minecraft.birch_fence_gate": "Portiella de bidul",
  "block.minecraft.birch_hanging_sign": "Cartel сolgante de abedul",
  "block.minecraft.birch_leaves": "Fueyes de bidul",
  "block.minecraft.birch_log": "Tueru de bidul",
  "block.minecraft.birch_planks": "Tables de bidul",
  "block.minecraft.birch_pressure_plate": "Placa de presión de bidul",
  "block.minecraft.birch_sapling": "Biltu de bidul",
  "block.minecraft.birch_shelf": "Estantería de bidul",
  "block.minecraft.birch_sign": "Cartelu de bidul",
  "block.minecraft.birch_slab": "Llábana de bidul",
  "block.minecraft.birch_stairs": "Pasales de bidul",
  "block.minecraft.birch_trapdoor": "Carbayu de bidul",
  "block.minecraft.birch_wall_hanging_sign": "Cartel de pared colgante de abedul",
  "block.minecraft.birch_wall_sign": "Cartelu de bidul na parede",
  "block.minecraft.birch_wood": "Madera de bidul con corteza",
  "block.minecraft.black_banner": "Estandarte prietu",
  "block.minecraft.black_bed": "Cama prieta",
  "block.minecraft.black_candle": "Vela prieta",
  "block.minecraft.black_candle_cake": "Tarta con una vela prieta",
  "block.minecraft.black_carpet": "Moqueta prieta",
  "block.minecraft.black_concrete": "Formigón prieto",
  "block.minecraft.black_concrete_powder": "Povisa de formigón prieto",
  "block.minecraft.black_glazed_terracotta": "Azulexu prietu",
  "block.minecraft.black_shulker_box": "Caxa prieta de shulker",
  "block.minecraft.black_stained_glass": "Vidru tintao en prieto",
  "block.minecraft.black_stained_glass_pane": "Panel de vidru tintao en prieto",
  "block.minecraft.black_terracotta": "Terracota prieto",
  "block.minecraft.black_wool": "Llana prieto",
  "block.minecraft.blackstone": "Nigrilitu",
  "block.minecraft.blackstone_slab": "Llábana de nigrilitu",
  "block.minecraft.blackstone_stairs": "Pasales de nigrilitu",
  "block.minecraft.blackstone_wall": "Muria de nigrilitu",
  "block.minecraft.blast_furnace": "Altu fornu",
  "block.minecraft.blue_banner": "Estandarte azul",
  "block.minecraft.blue_bed": "Cama azul",
  "block.minecraft.blue_candle": "Vela azul",
  "block.minecraft.blue_candle_cake": "Tarta con una vela azul",
  "block.minecraft.blue_carpet": "Moqueta azul",
  "block.minecraft.blue_concrete": "Formigón azul",
  "block.minecraft.blue_concrete_powder": "Povisa de formigón azul",
  "block.minecraft.blue_glazed_terracotta": "Azulexu azul",
  "block.minecraft.blue_ice": "Xelu",
  "block.minecraft.blue_orchid": "Orquídea azul",
  "block.minecraft.blue_shulker_box": "Caxa azul de shulker",
  "block.minecraft.blue_stained_glass": "Vidru tintao n'azul",
  "block.minecraft.blue_stained_glass_pane": "Panel de vidru tintao n'azul",
  "block.minecraft.blue_terracotta": "Terracota azul",
  "block.minecraft.blue_wool": "Llana azul",
  "block.minecraft.bone_block": "Bloque oseu",
  "block.minecraft.bookshelf": "Llibrería",
  "block.minecraft.brain_coral": "Coral de cerebru",
  "block.minecraft.brain_coral_block": "Bloque de coral de cerebru",
  "block.minecraft.brain_coral_fan": "Gorgonia de cerebru",
  "block.minecraft.brain_coral_wall_fan": "Gorgonia de cerebru de parede",
  "block.minecraft.brewing_stand": "Destilador",
  "block.minecraft.brick_slab": "Llábana de lladriyos",
  "block.minecraft.brick_stairs": "Pasales de lladriyos",
  "block.minecraft.brick_wall": "Muria de lladriyos",
  "block.minecraft.bricks": "Lladriyos",
  "block.minecraft.brown_banner": "Estandarte marrón",
  "block.minecraft.brown_bed": "Cama marrón",
  "block.minecraft.brown_candle": "Vela marrón",
  "block.minecraft.brown_candle_cake": "Tarta con una vela marrón",
  "block.minecraft.brown_carpet": "Moqueta marrón",
  "block.minecraft.brown_concrete": "Formigón marrón",
  "block.minecraft.brown_concrete_powder": "Povisa de formigón marrón",
  "block.minecraft.brown_glazed_terracotta": "Azulexu marrón",
  "block.minecraft.brown_mushroom": "Xampiñón",
  "block.minecraft.brown_mushroom_block": "Bloque de fungos marrones",
  "block.minecraft.brown_shulker_box": "Caxa marrón de shulker",
  "block.minecraft.brown_stained_glass": "Vidru tintao en marrón",
  "block.minecraft.brown_stained_glass_pane": "Panel de vidru tintao en marrón",
  "block.minecraft.brown_terracotta": "Terracota marrón",
  "block.minecraft.brown_wool": "Llana marrón",
  "block.minecraft.bubble_column": "Columna de borboyos",
  "block.minecraft.bubble_coral": "Coral de borboyos",
  "block.minecraft.bubble_coral_block": "Bloque de coral de borboyos",
  "block.minecraft.bubble_coral_fan": "Gorgonia de borboyos",
  "block.minecraft.bubble_coral_wall_fan": "Gorgonia de borboyos de parede",
  "block.minecraft.budding_amethyst": "Amatista naciente",
  "block.minecraft.bush": "Parrotal",
  "block.minecraft.cactus": "Cactus",
  "block.minecraft.cactus_flower": "Flor de cactus",
  "block.minecraft.cake": "Tarta",
  "block.minecraft.calcite": "Calcita",
  "block.minecraft.calibrated_sculk_sensor": "Sensor sculk calibráu",
  "block.minecraft.campfire": "Foguera",
  "block.minecraft.candle": "Vela",
  "block.minecraft.candle_cake": "Tarta con una vela",
  "block.minecraft.carrots": "Cenahories",
  "block.minecraft.cartography_table": "Mesa de cartografía",
  "block.minecraft.carved_pumpkin": "Calabaza tallada",
  "block.minecraft.cauldron": "Calderu",
  "block.minecraft.cave_air": "Aire de cueva",
  "block.minecraft.cave_vines": "Víes de cueva",
  "block.minecraft.cave_vines_plant": "Planta de vies de cueva",
  "block.minecraft.chain": "Cadena",
  "block.minecraft.chain_command_block": "Bloque de comandos en cadena",
  "block.minecraft.cherry_button": "Botón de cereza",
  "block.minecraft.cherry_door": "Puerta de cerezo",
  "block.minecraft.cherry_fence": "Valla de cerezu",
  "block.minecraft.cherry_fence_gate": "Portón de cerezu",
  "block.minecraft.cherry_hanging_sign": "Cartel colgante de cerezo",
  "block.minecraft.cherry_leaves": "Fueyes de cerezu",
  "block.minecraft.cherry_log": "Troncu de cerezu",
  "block.minecraft.cherry_planks": "Tablones de cerezu",
  "block.minecraft.cherry_pressure_plate": "Placa de presión de cerezu",
  "block.minecraft.cherry_sapling": "Renovellu de cerezu",
  "block.minecraft.cherry_shelf": "Estantería de cerezu",
  "block.minecraft.cherry_sign": "Señal de cerezu",
  "block.minecraft.cherry_slab": "Tabla de cerezu",
  "block.minecraft.cherry_stairs": "Escaleres de cerezu",
  "block.minecraft.cherry_trapdoor": "Escaleres de cerezu",
  "block.minecraft.cherry_wall_hanging_sign": "Señal de parede colgante de cerezu",
  "block.minecraft.cherry_wall_sign": "Señal de parede de cerezu",
  "block.minecraft.cherry_wood": "Madera de cerezu",
  "block.minecraft.chest": "Bagul",
  "block.minecraft.chipped_anvil": "Xuncla estellada",
  "block.minecraft.chiseled_bookshelf": "Librería trabayada a mano",
  "block.minecraft.chiseled_copper": "Cobre talláu",
  "block.minecraft.chiseled_deepslate": "Pizarra cincelao",
  "block.minecraft.chiseled_nether_bricks": "Lladriyos del Nether cincelaos",
  "block.minecraft.chiseled_polished_blackstone": "Nigrilitu pulío ya cincelao",
  "block.minecraft.chiseled_quartz_block": "Bloque de cuarzu cincelao",
  "block.minecraft.chiseled_red_sandstone": "Gres colorao cincelao",
  "block.minecraft.chiseled_resin_bricks": "Lladriyos de resina cincelaos",
  "block.minecraft.chiseled_sandstone": "Gres cincelao",
  "block.minecraft.chiseled_stone_bricks": "Lladriyos de piedra cincelao",
  "block.minecraft.chiseled_tuff": "Tufu esculpíu",
  "block.minecraft.chiseled_tuff_bricks": "Lladríos de tufu esculpíos",
  "block.minecraft.chorus_flower": "Flor del Coru",
  "block.minecraft.chorus_plant": "Planta del Coru",
  "block.minecraft.clay": "Barru santo",
  "block.minecraft.closed_eyeblossom": "Miraflor cerrada",
  "block.minecraft.coal_block": "Bloque de carbón",
  "block.minecraft.coal_ore": "Veta de carbón",
  "block.minecraft.coarse_dirt": "Tierra seco",
  "block.minecraft.cobbled_deepslate": "Llastra de pizarra",
  "block.minecraft.cobbled_deepslate_slab": "Llábana de llastra de pizarra",
  "block.minecraft.cobbled_deepslate_stairs": "Pasales de llastra de pizarra",
  "block.minecraft.cobbled_deepslate_wall": "Muria de llastra de pizarra",
  "block.minecraft.cobblestone": "Llastra",
  "block.minecraft.cobblestone_slab": "Llábana de llastra",
  "block.minecraft.cobblestone_stairs": "Pasales de llastra",
  "block.minecraft.cobblestone_wall": "Muria de llastra",
  "block.minecraft.cobweb": "Telaraña",
  "block.minecraft.cocoa": "Cacáu",
  "block.minecraft.command_block": "Bloque de comandos",
  "block.minecraft.comparator": "Comparador de redstone",
  "block.minecraft.composter": "Compostador",
  "block.minecraft.conduit": "Canalizador",
  "block.minecraft.copper_bars": "Barrotes de cobre",
  "block.minecraft.copper_block": "Bloque de cobre",
  "block.minecraft.copper_bulb": "Bombía de cobre",
  "block.minecraft.copper_chain": "Cadena de cobre",
  "block.minecraft.copper_chest": "Bagul de cobre",
  "block.minecraft.copper_door": "Puerta de cobre",
  "block.minecraft.copper_golem_statue": "Estatua de gólem de cobre",
  "block.minecraft.copper_grate": "Reixeta de cobre",
  "block.minecraft.copper_lantern": "Llámpara de cobre",
  "block.minecraft.copper_ore": "Veta de cobre",
  "block.minecraft.copper_torch": "Antorcha de cobre",
  "block.minecraft.copper_trapdoor": "Reixeta de cobre",
  "block.minecraft.copper_wall_torch": "Antorcha de cobre en paré",
  "block.minecraft.cornflower": "Clavelina",
  "block.minecraft.cracked_deepslate_bricks": "Lladriyos de pizarra frañaos",
  "block.minecraft.cracked_deepslate_tiles": "Azulexos de pizarra frañaos",
  "block.minecraft.cracked_nether_bricks": "Lladriyos del Nether frañaos",
  "block.minecraft.cracked_polished_blackstone_bricks": "Lladriyos de nigrilitu pulío frañaos",
  "block.minecraft.cracked_stone_bricks": "Lladriyos de piedra frañaos",
  "block.minecraft.crafter": "Artesán",
  "block.minecraft.crafting_table": "Mesa d'ellaboración",
  "block.minecraft.creaking_heart": "Corazón Crespu",
  "block.minecraft.creeper_head": "Tiesta de Creeper",
  "block.minecraft.creeper_wall_head": "Tiesta de creeper na parede",
  "block.minecraft.crimson_button": "Botón carmesín",
  "block.minecraft.crimson_door": "Puerta carmesina",
  "block.minecraft.crimson_fence": "Valla carmesina",
  "block.minecraft.crimson_fence_gate": "Portiella carmesina",
  "block.minecraft.crimson_fungus": "Fungu carmesín",
  "block.minecraft.crimson_hanging_sign": "Cartel colgante carmesí",
  "block.minecraft.crimson_hyphae": "Hixas carmesí",
  "block.minecraft.crimson_nylium": "Niliu carmesín",
  "block.minecraft.crimson_planks": "Tables carmesines",
  "block.minecraft.crimson_pressure_plate": "Placa de presión carmesín",
  "block.minecraft.crimson_roots": "Yerba carmesín",
  "block.minecraft.crimson_shelf": "Estantería carmesina",
  "block.minecraft.crimson_sign": "Cartelu carmesín",
  "block.minecraft.crimson_slab": "Llábana carmesina",
  "block.minecraft.crimson_stairs": "Pasales carmesinos",
  "block.minecraft.crimson_stem": "Madera carmesín",
  "block.minecraft.crimson_trapdoor": "Trapiella carmesina",
  "block.minecraft.crimson_wall_hanging_sign": "Cartel coleandero de muria carmesín",
  "block.minecraft.crimson_wall_sign": "Cartel de muria carmesí",
  "block.minecraft.crying_obsidian": "Obsidiana lloroso",
  "block.minecraft.cut_copper": "Cobre cortao",
  "block.minecraft.cut_copper_slab": "Llábana de cobre cortao",
  "block.minecraft.cut_copper_stairs": "Pasales de cobre cortao",
  "block.minecraft.cut_red_sandstone": "Gres colorao cortao",
  "block.minecraft.cut_red_sandstone_slab": "Llábana de gres colorao cortao",
  "block.minecraft.cut_sandstone": "Gres cortao",
  "block.minecraft.cut_sandstone_slab": "Llábana de gres cortao",
  "block.minecraft.cyan_banner": "Estandarte cianu",
  "block.minecraft.cyan_bed": "Cama ciana",
  "block.minecraft.cyan_candle": "Vela ciana",
  "block.minecraft.cyan_candle_cake": "Tarta con una vela ciana",
  "block.minecraft.cyan_carpet": "Moqueta ciana",
  "block.minecraft.cyan_concrete": "Formigón ciano",
  "block.minecraft.cyan_concrete_powder": "Povisa de formigón ciano",
  "block.minecraft.cyan_glazed_terracotta": "Azulexu cianu",
  "block.minecraft.cyan_shulker_box": "Caxa ciana de shulker",
  "block.minecraft.cyan_stained_glass": "Vidru tintao en ciano",
  "block.minecraft.cyan_stained_glass_pane": "Panel de vidru tintao en ciano",
  "block.minecraft.cyan_terracotta": "Terracota ciano",
  "block.minecraft.cyan_wool": "Llana ciano",
  "block.minecraft.damaged_anvil": "Xuncla perdañada",
  "block.minecraft.dandelion": "Xiblata",
  "block.minecraft.dark_oak_button": "Botón de carbayu escuro",
  "block.minecraft.dark_oak_door": "Puerta de carbayu escuro",
  "block.minecraft.dark_oak_fence": "Valla de carbayu escuro",
  "block.minecraft.dark_oak_fence_gate": "Portiella de carbayu escuro",
  "block.minecraft.dark_oak_hanging_sign": "Cartel colgante de roble oscuro",
  "block.minecraft.dark_oak_leaves": "Fueyes de carbayu escuro",
  "block.minecraft.dark_oak_log": "Tueru de carbayu escuro",
  "block.minecraft.dark_oak_planks": "Tables de carbayu escuro",
  "block.minecraft.dark_oak_pressure_plate": "Placa de presión de carbayu escuro",
  "block.minecraft.dark_oak_sapling": "Biltu de carbayu escuro",
  "block.minecraft.dark_oak_shelf": "Estantería de carbayu escuro",
  "block.minecraft.dark_oak_sign": "Cartelu de carbayu escuro",
  "block.minecraft.dark_oak_slab": "Llábana de carbayu escuro",
  "block.minecraft.dark_oak_stairs": "Pasales de carbayu escuro",
  "block.minecraft.dark_oak_trapdoor": "Trapiella de carbayu escuro",
  "block.minecraft.dark_oak_wall_hanging_sign": "Cartel colgante de roble oscuro",
  "block.minecraft.dark_oak_wall_sign": "Cartelu de carbayu escuro na parede",
  "block.minecraft.dark_oak_wood": "Madera de carbayu escuro con corteza",
  "block.minecraft.dark_prismarine": "Prismarín escuro",
  "block.minecraft.dark_prismarine_slab": "Llábana de prismarín escuro",
  "block.minecraft.dark_prismarine_stairs": "Pasales de prismarín escuro",
  "block.minecraft.daylight_detector": "Sensor de llume solar",
  "block.minecraft.dead_brain_coral": "Coral de cerebru muerto",
  "block.minecraft.dead_brain_coral_block": "Bloque de coral de cerebru muerto",
  "block.minecraft.dead_brain_coral_fan": "Gorgonia de cerebru muerto",
  "block.minecraft.dead_brain_coral_wall_fan": "Gorgonia de cerebros muerto de parede",
  "block.minecraft.dead_bubble_coral": "Coral de borboyos muerto",
  "block.minecraft.dead_bubble_coral_block": "Bloque de coral de borboyos muerto",
  "block.minecraft.dead_bubble_coral_fan": "Gorgonia de borboyos muerto",
  "block.minecraft.dead_bubble_coral_wall_fan": "Gorgonia de borboyos muerto de parede",
  "block.minecraft.dead_bush": "Plantu muertu",
  "block.minecraft.dead_fire_coral": "Coral de fueu muerto",
  "block.minecraft.dead_fire_coral_block": "Bloque de coral de fueu muerto",
  "block.minecraft.dead_fire_coral_fan": "Gorgonia de fueu muerto",
  "block.minecraft.dead_fire_coral_wall_fan": "Gorgonia de fueu muerto de parede",
  "block.minecraft.dead_horn_coral": "Coral de cuernos muerto",
  "block.minecraft.dead_horn_coral_block": "Bloque de coral de cuernos muerto",
  "block.minecraft.dead_horn_coral_fan": "Gorgonia de cuernos muerto",
  "block.minecraft.dead_horn_coral_wall_fan": "Gorgonia de cuernos muerto de parede",
  "block.minecraft.dead_tube_coral": "Coral de tubos muerto",
  "block.minecraft.dead_tube_coral_block": "Bloque de coral de tubos muerto",
  "block.minecraft.dead_tube_coral_fan": "Gorgonia de tubos muerto",
  "block.minecraft.dead_tube_coral_wall_fan": "Gorgonia de tubos muerto de parede",
  "block.minecraft.decorated_pot": "Maceta decorada",
  "block.minecraft.deepslate": "Pizarra",
  "block.minecraft.deepslate_brick_slab": "Llábana de lladriyos de pizarra",
  "block.minecraft.deepslate_brick_stairs": "Pasales de lladriyos de pizarra",
  "block.minecraft.deepslate_brick_wall": "Muria de lladriyos de pizarra",
  "block.minecraft.deepslate_bricks": "Lladriyos de pizarra",
  "block.minecraft.deepslate_coal_ore": "Veta de carbón en pizarra",
  "block.minecraft.deepslate_copper_ore": "Veta de cobre en pizarra",
  "block.minecraft.deepslate_diamond_ore": "Veta de diamante en pizarra",
  "block.minecraft.deepslate_emerald_ore": "Veta d'esmeralda en pizarra",
  "block.minecraft.deepslate_gold_ore": "Veta d'oru en pizarra",
  "block.minecraft.deepslate_iron_ore": "Veta de fierro en pizarra",
  "block.minecraft.deepslate_lapis_ore": "Veta de llapislázuli en pizarra",
  "block.minecraft.deepslate_redstone_ore": "Veta de redstone en pizarra",
  "block.minecraft.deepslate_tile_slab": "Llábana d'azulexos de pizarra",
  "block.minecraft.deepslate_tile_stairs": "Pasales d'azulexos de pizarra",
  "block.minecraft.deepslate_tile_wall": "Muria d'azulexos de pizarra",
  "block.minecraft.deepslate_tiles": "Azulexos de pizarra",
  "block.minecraft.detector_rail": "Vía detectora",
  "block.minecraft.diamond_block": "Bloque de diamante",
  "block.minecraft.diamond_ore": "Veta de diamante",
  "block.minecraft.diorite": "Diorita",
  "block.minecraft.diorite_slab": "Llábana de diorita",
  "block.minecraft.diorite_stairs": "Pasales de diorita",
  "block.minecraft.diorite_wall": "Muria de diorita",
  "block.minecraft.dirt": "Tierra",
  "block.minecraft.dirt_path": "Camín de tierra",
  "block.minecraft.dispenser": "Llanzador",
  "block.minecraft.dragon_egg": "Güevu de cuélebre",
  "block.minecraft.dragon_head": "Tiesta de cuélebre",
  "block.minecraft.dragon_wall_head": "Tiesta de cuélebre na parede",
  "block.minecraft.dried_ghast": "Ghast seco",
  "block.minecraft.dried_kelp_block": "Bloque de laminarial seco",
  "block.minecraft.dripstone_block": "Bloque d'espeleotema",
  "block.minecraft.dropper": "Apurridor",
  "block.minecraft.emerald_block": "Bloque d'esmeralda",
  "block.minecraft.emerald_ore": "Veta d'esmeralda",
  "block.minecraft.enchanting_table": "Mesa d'encantexos",
  "block.minecraft.end_gateway": "Pasera al End",
  "block.minecraft.end_portal": "Portal del End",
  "block.minecraft.end_portal_frame": "Marcu d'un portal al End",
  "block.minecraft.end_rod": "Vara del End",
  "block.minecraft.end_stone": "Piedra del End",
  "block.minecraft.end_stone_brick_slab": "Llábana de lladriyos del End",
  "block.minecraft.end_stone_brick_stairs": "Pasales de lladriyos del End",
  "block.minecraft.end_stone_brick_wall": "Muria de lladriyos de piedra del End",
  "block.minecraft.end_stone_bricks": "Lladriyos de piedra del End",
  "block.minecraft.ender_chest": "Bagul d'Ender",
  "block.minecraft.exposed_chiseled_copper": "Cobre cincelado expuesto",
  "block.minecraft.exposed_copper": "Cobre espuesto",
  "block.minecraft.exposed_copper_bars": "Barrotes de cobre espuesto",
  "block.minecraft.exposed_copper_bulb": "Bombilla de cobre expuesta",
  "block.minecraft.exposed_copper_chain": "Cadena de cobre espuesto",
  "block.minecraft.exposed_copper_chest": "Bagul de cobre espuesto",
  "block.minecraft.exposed_copper_door": "Puerta de cobre expuesta",
  "block.minecraft.exposed_copper_golem_statue": "Estatua de Gólem de Cobre Espuesta",
  "block.minecraft.exposed_copper_grate": "Reixa de cobre espuesta",
  "block.minecraft.exposed_copper_lantern": "Llámpara de cobre espuesto",
  "block.minecraft.exposed_copper_trapdoor": "Trampa de cobre expuesta",
  "block.minecraft.exposed_cut_copper": "Cobre cortado expuesto",
  "block.minecraft.exposed_cut_copper_slab": "Loza de cobre cortada expuesta",
  "block.minecraft.exposed_cut_copper_stairs": "Escaleras de cobre cortadas expuestas",
  "block.minecraft.exposed_lightning_rod": "Pararrayos espuestu",
  "block.minecraft.farmland": "Bloque d'eru",
  "block.minecraft.fern": "Felechu",
  "block.minecraft.fire": "Fueu",
  "block.minecraft.fire_coral": "Coral de fueu",
  "block.minecraft.fire_coral_block": "Bloque de coral de fueu",
  "block.minecraft.fire_coral_fan": "Gorgonia de fueu",
  "block.minecraft.fire_coral_wall_fan": "Gorgonia de fueu de parede",
  "block.minecraft.firefly_bush": "Parrotal de lluciérnagas",
  "block.minecraft.fletching_table": "Mesa de fleches",
  "block.minecraft.flower_pot": "Tiestu",
  "block.minecraft.flowering_azalea": "Rododendru florecío",
  "block.minecraft.flowering_azalea_leaves": "Fueyes de rododentru florecío",
  "block.minecraft.frogspawn": "Asoccançada de sapos",
  "block.minecraft.frosted_ice": "Xelada",
  "block.minecraft.furnace": "Fornu",
  "block.minecraft.gilded_blackstone": "Nigrilitu con oru",
  "block.minecraft.glass": "Vidru",
  "block.minecraft.glass_pane": "Panel de vidru",
  "block.minecraft.glow_lichen": "Lique rellumante",
  "block.minecraft.glowstone": "Piedra rellumante",
  "block.minecraft.gold_block": "Bloque d'oru",
  "block.minecraft.gold_ore": "Veta d'oru",
  "block.minecraft.golden_dandelion": "Cardeña dorada",
  "block.minecraft.granite": "Granitu",
  "block.minecraft.granite_slab": "Llábana de granitu",
  "block.minecraft.granite_stairs": "Pasales de granitu",
  "block.minecraft.granite_wall": "Muria de granitu",
  "block.minecraft.grass": "Yerba",
  "block.minecraft.grass_block": "Tapín",
  "block.minecraft.gravel": "Grava",
  "block.minecraft.gray_banner": "Estandarte buxu",
  "block.minecraft.gray_bed": "Cama buxa",
  "block.minecraft.gray_candle": "Vela buxa",
  "block.minecraft.gray_candle_cake": "Tarta con una vela buxa",
  "block.minecraft.gray_carpet": "Moqueta buxa",
  "block.minecraft.gray_concrete": "Formigón buxo",
  "block.minecraft.gray_concrete_powder": "Povisa de formigón buxo",
  "block.minecraft.gray_glazed_terracotta": "Azulexu buxu",
  "block.minecraft.gray_shulker_box": "Caxa buxa de shulker",
  "block.minecraft.gray_stained_glass": "Vidru tintao en buxo",
  "block.minecraft.gray_stained_glass_pane": "Panel de vidru tintao en buxo",
  "block.minecraft.gray_terracotta": "Terracota buxo",
  "block.minecraft.gray_wool": "Llana buxo",
  "block.minecraft.green_banner": "Estandarte verde",
  "block.minecraft.green_bed": "Cama verde",
  "block.minecraft.green_candle": "Vela verde",
  "block.minecraft.green_candle_cake": "Tarta con una vela verde",
  "block.minecraft.green_carpet": "Moqueta verde",
  "block.minecraft.green_concrete": "Formigón verde",
  "block.minecraft.green_concrete_powder": "Povisa de formigón verde",
  "block.minecraft.green_glazed_terracotta": "Azulexu verde",
  "block.minecraft.green_shulker_box": "Caxa verde de shulker",
  "block.minecraft.green_stained_glass": "Vidru tintao en verde",
  "block.minecraft.green_stained_glass_pane": "Panel de vidru tintao en verde",
  "block.minecraft.green_terracotta": "Terracota verde",
  "block.minecraft.green_wool": "Llana verde",
  "block.minecraft.grindstone": "Piedra p'amolar",
  "block.minecraft.hanging_roots": " Raíces colgantes",
  "block.minecraft.hay_block": "Paca",
  "block.minecraft.heavy_core": "Núcleu pesáu",
  "block.minecraft.heavy_weighted_pressure_plate": "Placa de presión pa pesu pesáu",
  "block.minecraft.honey_block": "Bloque de miel",
  "block.minecraft.honeycomb_block": "Bloque de caxellos",
  "block.minecraft.hopper": "Embudu",
  "block.minecraft.horn_coral": "Coral de cuernos",
  "block.minecraft.horn_coral_block": "Bloque de coral de cuernos",
  "block.minecraft.horn_coral_fan": "Gorgonia de cuernos",
  "block.minecraft.horn_coral_wall_fan": "Gorgonia de tubos de parede",
  "block.minecraft.ice": "Xelu",
  "block.minecraft.infested_chiseled_stone_bricks": "Lladriyos de piedra cincelao infestaos",
  "block.minecraft.infested_cobblestone": "Llastra infestao",
  "block.minecraft.infested_cracked_stone_bricks": "Lladriyos de piedra frañíos ya infestaos",
  "block.minecraft.infested_deepslate": "Pizarra infestao",
  "block.minecraft.infested_mossy_stone_bricks": "Lladriyos de piedra mofoso ya infestao",
  "block.minecraft.infested_stone": "Piedra infestao",
  "block.minecraft.infested_stone_bricks": "Lladriyos de piedra infestao",
  "block.minecraft.iron_bars": "Barrotes de fierro",
  "block.minecraft.iron_block": "Bloque de fierro",
  "block.minecraft.iron_chain": "Cadena de fierro",
  "block.minecraft.iron_door": "Puerta de fierro",
  "block.minecraft.iron_ore": "Veta de fierro",
  "block.minecraft.iron_trapdoor": "Trapiella de fierro",
  "block.minecraft.jack_o_lantern": "Jack o'Lantern",
  "block.minecraft.jigsaw": "Bloque de tétramuxería",
  "block.minecraft.jukebox": "Tocadiscos",
  "block.minecraft.jungle_button": "Botón de madera de la xungla",
  "block.minecraft.jungle_door": "Puerta de madera de la xungla",
  "block.minecraft.jungle_fence": "Valla de madera de la xungla",
  "block.minecraft.jungle_fence_gate": "Portiella de madera de la xungla",
  "block.minecraft.jungle_hanging_sign": "Señal colgante de la selva",
  "block.minecraft.jungle_leaves": "Fueyes de la xungla",
  "block.minecraft.jungle_log": "Tueru de madera de la xungla",
  "block.minecraft.jungle_planks": "Tables de madera de la xungla",
  "block.minecraft.jungle_pressure_plate": "Placa de presión de madera de la xungla",
  "block.minecraft.jungle_sapling": "Biltu de la xungla",
  "block.minecraft.jungle_shelf": "Estantería de xungla",
  "block.minecraft.jungle_sign": "Cartelu de madera de la xungla",
  "block.minecraft.jungle_slab": "Llábana de madera de la xungla",
  "block.minecraft.jungle_stairs": "Pasales de madera de la xungla",
  "block.minecraft.jungle_trapdoor": "Trapiella de madera de la xungla",
  "block.minecraft.jungle_wall_hanging_sign": "Paniellu colgante de la muria de la selva",
  "block.minecraft.jungle_wall_sign": "Cartelu de madera de la xungla na parede",
  "block.minecraft.jungle_wood": "Madera de la xungla con corteza",
  "block.minecraft.kelp": "Laminarial",
  "block.minecraft.kelp_plant": "Biltu de laminarial",
  "block.minecraft.ladder": "Escalera de mano",
  "block.minecraft.lantern": "Llámpara",
  "block.minecraft.lapis_block": "Bloque de llapislázuli",
  "block.minecraft.lapis_ore": "Veta de llapislázuli",
  "block.minecraft.large_amethyst_bud": "Broche de amatista grande",
  "block.minecraft.large_fern": "Felechu grande",
  "block.minecraft.lava": "Llava",
  "block.minecraft.lava_cauldron": "Calderu con llava",
  "block.minecraft.leaf_litter": "Fueyes seques",
  "block.minecraft.lectern": "Atril",
  "block.minecraft.lever": "Palanca",
  "block.minecraft.light": "Lluz",
  "block.minecraft.light_blue_banner": "Estandarte azul claru",
  "block.minecraft.light_blue_bed": "Cama azul claro",
  "block.minecraft.light_blue_candle": "Vela azul claro",
  "block.minecraft.light_blue_candle_cake": "Tarta con cendra azul claru",
  "block.minecraft.light_blue_carpet": "Moqueta azul claro",
  "block.minecraft.light_blue_concrete": "Formigón azul claro",
  "block.minecraft.light_blue_concrete_powder": "Povisa de formigón azul claro",
  "block.minecraft.light_blue_glazed_terracotta": "Azulexu azul claro",
  "block.minecraft.light_blue_shulker_box": "Caxa azul claro de shulker",
  "block.minecraft.light_blue_stained_glass": "Vidru tintao n'azul claro",
  "block.minecraft.light_blue_stained_glass_pane": "Panel de vidru tintao n'azul claro",
  "block.minecraft.light_blue_terracotta": "Terracota azul claro",
  "block.minecraft.light_blue_wool": "Llana azul claro",
  "block.minecraft.light_gray_banner": "Estandarte buxu claru",
  "block.minecraft.light_gray_bed": "Cama buxo claro",
  "block.minecraft.light_gray_candle": "Vela gris clara",
  "block.minecraft.light_gray_candle_cake": "Tarta con vela gris clara",
  "block.minecraft.light_gray_carpet": "Moqueta buxa clara",
  "block.minecraft.light_gray_concrete": "Formigón buxo claro",
  "block.minecraft.light_gray_concrete_powder": "Povisa de formigón buxo claro",
  "block.minecraft.light_gray_glazed_terracotta": "Azulexu buxu claro",
  "block.minecraft.light_gray_shulker_box": "Caxa buxa claro de shulker",
  "block.minecraft.light_gray_stained_glass": "Vidru tintao en buxo claro",
  "block.minecraft.light_gray_stained_glass_pane": "Panel de vidru tintao en buxo claro",
  "block.minecraft.light_gray_terracotta": "Terracota buxo claro",
  "block.minecraft.light_gray_wool": "Llana buxo claro",
  "block.minecraft.light_weighted_pressure_plate": "Placa de presión pa pesu llixeru",
  "block.minecraft.lightning_rod": "Pararrayos",
  "block.minecraft.lilac": "Lilá",
  "block.minecraft.lily_of_the_valley": "Lliriu de los valles",
  "block.minecraft.lily_pad": "Nenúfar",
  "block.minecraft.lime_banner": "Estandarte llima",
  "block.minecraft.lime_bed": "Cama llima",
  "block.minecraft.lime_candle": "Vela llima",
  "block.minecraft.lime_candle_cake": "Tarta con una vela llima",
  "block.minecraft.lime_carpet": "Moqueta llima",
  "block.minecraft.lime_concrete": "Formigón llima",
  "block.minecraft.lime_concrete_powder": "Povisa de formigón llima",
  "block.minecraft.lime_glazed_terracotta": "Azulexu llima",
  "block.minecraft.lime_shulker_box": "Caxa llima de shulker",
  "block.minecraft.lime_stained_glass": "Vidru tintao en llima",
  "block.minecraft.lime_stained_glass_pane": "Panel de vidru tintao en llima",
  "block.minecraft.lime_terracotta": "Terracota llima",
  "block.minecraft.lime_wool": "Llana llima",
  "block.minecraft.lodestone": "Magnetita",
  "block.minecraft.loom": "Telar",
  "block.minecraft.magenta_banner": "Estandarte maxenta",
  "block.minecraft.magenta_bed": "Cama maxenta",
  "block.minecraft.magenta_candle": "Vela maxenta",
  "block.minecraft.magenta_candle_cake": "Tarta con una vela maxenta",
  "block.minecraft.magenta_carpet": "Moqueta maxenta",
  "block.minecraft.magenta_concrete": "Formigón maxenta",
  "block.minecraft.magenta_concrete_powder": "Povisa de formigón maxenta",
  "block.minecraft.magenta_glazed_terracotta": "Azulexu maxenta",
  "block.minecraft.magenta_shulker_box": "Caxa maxenta de shulker",
  "block.minecraft.magenta_stained_glass": "Vidru tintao en maxenta",
  "block.minecraft.magenta_stained_glass_pane": "Panel de vidru tintao en maxenta",
  "block.minecraft.magenta_terracotta": "Terracota maxenta",
  "block.minecraft.magenta_wool": "Llana maxenta",
  "block.minecraft.magma_block": "Bloque magmáticu",
  "block.minecraft.mangrove_button": "Botón de manglar",
  "block.minecraft.mangrove_door": "Puerta de manglar",
  "block.minecraft.mangrove_fence": "Madera de manglar",
  "block.minecraft.mangrove_fence_gate": "Puerta de cercu de mangle",
  "block.minecraft.mangrove_hanging_sign": "Cartel colgante de mangle",
  "block.minecraft.mangrove_leaves": "Fueyes de manglar",
  "block.minecraft.mangrove_log": "Tronco de mangle",
  "block.minecraft.mangrove_planks": "Tablones de mangle",
  "block.minecraft.mangrove_pressure_plate": "Placa de presión de mangle",
  "block.minecraft.mangrove_propagule": "Propágulo de mangle",
  "block.minecraft.mangrove_roots": "Raíces de manglar",
  "block.minecraft.mangrove_shelf": "Estantería de mangle",
  "block.minecraft.mangrove_sign": "Signo de manglar",
  "block.minecraft.mangrove_slab": "Llancha de manglar",
  "block.minecraft.mangrove_stairs": "Escaleres de manglar",
  "block.minecraft.mangrove_trapdoor": "Portella de manglar",
  "block.minecraft.mangrove_wall_hanging_sign": "Cartel de pared de mangle colgante",
  "block.minecraft.mangrove_wall_sign": "Cartel de pared de mangle",
  "block.minecraft.mangrove_wood": "Madera de mangle",
  "block.minecraft.medium_amethyst_bud": "Brotu mediu de ametista",
  "block.minecraft.melon": "Sandía",
  "block.minecraft.melon_stem": "Tallu de sandía",
  "block.minecraft.moss_block": "Bloque de mofu",
  "block.minecraft.moss_carpet": "Moqueta de mofu",
  "block.minecraft.mossy_cobblestone": "Llastra mofoso",
  "block.minecraft.mossy_cobblestone_slab": "Llábana de llastra mofoso",
  "block.minecraft.mossy_cobblestone_stairs": "Pasales de llastra mofoso",
  "block.minecraft.mossy_cobblestone_wall": "Muria de llastra mofoso",
  "block.minecraft.mossy_stone_brick_slab": "Llábana de lladriyos de piedra mofosa",
  "block.minecraft.mossy_stone_brick_stairs": "Pasales de lladriyos de piedra mofosa",
  "block.minecraft.mossy_stone_brick_wall": "Muria de lladriyos de piedra mofosa",
  "block.minecraft.mossy_stone_bricks": "Lladriyos de piedra mofosa",
  "block.minecraft.moving_piston": "Piston que se mueve",
  "block.minecraft.mud": "Barru",
  "block.minecraft.mud_brick_slab": "Llábana de lladriyu de Barru",
  "block.minecraft.mud_brick_stairs": "Escaleres de lladriyu de barru",
  "block.minecraft.mud_brick_wall": "Muria de Lladriyu de Barru",
  "block.minecraft.mud_bricks": "Lladriyos de Barru",
  "block.minecraft.muddy_mangrove_roots": "Raigañu fangosu de mangle",
  "block.minecraft.mushroom_stem": "Tallu de fungu",
  "block.minecraft.mycelium": "Miceliu",
  "block.minecraft.nether_brick_fence": "Valla de lladriyos del Nether",
  "block.minecraft.nether_brick_slab": "Llábana de lladriyos del Nether",
  "block.minecraft.nether_brick_stairs": "Pasales de lladriyos del Nether",
  "block.minecraft.nether_brick_wall": "Muria de lladriyos del Nether",
  "block.minecraft.nether_bricks": "Lladriyos del Nether",
  "block.minecraft.nether_gold_ore": "Veta d'oru del Nether",
  "block.minecraft.nether_portal": "Portal al Nether",
  "block.minecraft.nether_quartz_ore": "Veta de cuarzu del Nether",
  "block.minecraft.nether_sprouts": "Brootes de l'infern",
  "block.minecraft.nether_wart": "Fungu del Nether",
  "block.minecraft.nether_wart_block": "Bloque d'úzara del Nether",
  "block.minecraft.netherite_block": "Bloque de netherita",
  "block.minecraft.netherrack": "Netherrack",
  "block.minecraft.note_block": "Bloque de notes",
  "block.minecraft.oak_button": "Botón de carbayu",
  "block.minecraft.oak_door": "Puerta de carbayu",
  "block.minecraft.oak_fence": "Valla de carbayu",
  "block.minecraft.oak_fence_gate": "Portiella de carbayu",
  "block.minecraft.oak_hanging_sign": "Cartel colgante de branu",
  "block.minecraft.oak_leaves": "Fueyes de carbayu",
  "block.minecraft.oak_log": "Tueru de carbayu",
  "block.minecraft.oak_planks": "Tables de carbayu",
  "block.minecraft.oak_pressure_plate": "Placa de presión de carbayu",
  "block.minecraft.oak_sapling": "Biltu de carbayu",
  "block.minecraft.oak_shelf": "Estantería de carbayu",
  "block.minecraft.oak_sign": "Cartelu de carbayu",
  "block.minecraft.oak_slab": "Llábana de carbayu",
  "block.minecraft.oak_stairs": "Pasales de carbayu",
  "block.minecraft.oak_trapdoor": "Trapiella de carbayu",
  "block.minecraft.oak_wall_hanging_sign": "Cartel colgante de branu de l'arriu",
  "block.minecraft.oak_wall_sign": "Cartelu de carbayu na parede",
  "block.minecraft.oak_wood": "Madera de carbayu con corteza",
  "block.minecraft.observer": "Observador",
  "block.minecraft.obsidian": "Obsidiana",
  "block.minecraft.ochre_froglight": "Xaroncalluz ocre",
  "block.minecraft.ominous_banner": "Estandarte siniestru",
  "block.minecraft.open_eyeblossom": "Miraflor abierta",
  "block.minecraft.orange_banner": "Estandarte naranxa",
  "block.minecraft.orange_bed": "Cama naranxa",
  "block.minecraft.orange_candle": "Vela naranxa",
  "block.minecraft.orange_candle_cake": "Tarta con una vela naranxa",
  "block.minecraft.orange_carpet": "Moqueta naranxa",
  "block.minecraft.orange_concrete": "Formigón naranxa",
  "block.minecraft.orange_concrete_powder": "Povisa de formigón naranxa",
  "block.minecraft.orange_glazed_terracotta": "Azulexu naranxa",
  "block.minecraft.orange_shulker_box": "Caxa naranxa de shulker",
  "block.minecraft.orange_stained_glass": "Vidru tintao en naranxa",
  "block.minecraft.orange_stained_glass_pane": "Panel de vidru tintao en naranxa",
  "block.minecraft.orange_terracotta": "Terracota naranxa",
  "block.minecraft.orange_tulip": "Tulipán naranxa",
  "block.minecraft.orange_wool": "Llana naranxa",
  "block.minecraft.oxeye_daisy": "Catasol grande",
  "block.minecraft.oxidized_chiseled_copper": "Cobru ciselláu oxidáu",
  "block.minecraft.oxidized_copper": "Cobre oxidao",
  "block.minecraft.oxidized_copper_bars": "Barres de cobre ferruñoso",
  "block.minecraft.oxidized_copper_bulb": "Bombiella de cobru oxidáu",
  "block.minecraft.oxidized_copper_chain": "Cadena de cobre ferruñoso",
  "block.minecraft.oxidized_copper_chest": "Bagul de cobre ferruñoso",
  "block.minecraft.oxidized_copper_door": "Puerta de cobru oxidáu",
  "block.minecraft.oxidized_copper_golem_statue": "Estatua de Gólem de Cobre Ferruñosu",
  "block.minecraft.oxidized_copper_grate": "Reixa de cobru oxidáu",
  "block.minecraft.oxidized_copper_lantern": "Farol de Cobre Ferruñosu",
  "block.minecraft.oxidized_copper_trapdoor": "Trampexa de cobru oxidáu",
  "block.minecraft.oxidized_cut_copper": "Cobre cortao oxidao",
  "block.minecraft.oxidized_cut_copper_slab": "Llábana de cobre cortao oxidada",
  "block.minecraft.oxidized_cut_copper_stairs": "Pasales de cobre cortao oxidaos",
  "block.minecraft.oxidized_lightning_rod": "Pararrayos de Cobre Ferruñosu",
  "block.minecraft.packed_ice": "Xelu compauto",
  "block.minecraft.packed_mud": "Barru Compauto",
  "block.minecraft.pale_hanging_moss": "Mofu pálido colgante",
  "block.minecraft.pale_moss_block": "Bloque de mofu pálido",
  "block.minecraft.pale_moss_carpet": "Alfombra de mofu pálido",
  "block.minecraft.pale_oak_button": "Botón de carbayu pálido",
  "block.minecraft.pale_oak_door": "Puerta de carbayu pálido",
  "block.minecraft.pale_oak_fence": "Valla de carbayu pálido",
  "block.minecraft.pale_oak_fence_gate": "Puerta de valla de carbayu pálido",
  "block.minecraft.pale_oak_hanging_sign": "Cartelu colgante de carbayu pálido",
  "block.minecraft.pale_oak_leaves": "Fueyes de carbayu pálido",
  "block.minecraft.pale_oak_log": "Tueru de carbayu pálido",
  "block.minecraft.pale_oak_planks": "Tablones de carbayu pálido",
  "block.minecraft.pale_oak_pressure_plate": "Placa de presión de carbayu pálido",
  "block.minecraft.pale_oak_sapling": "Biltu de carbayu pálido",
  "block.minecraft.pale_oak_shelf": "Estantería de carbayu pálido",
  "block.minecraft.pale_oak_sign": "Cartelu de carbayu pálido",
  "block.minecraft.pale_oak_slab": "Llosa de carbayu pálido",
  "block.minecraft.pale_oak_stairs": "Escaleres de carbayu pálido",
  "block.minecraft.pale_oak_trapdoor": "Trapiella de carbayu pálido",
  "block.minecraft.pale_oak_wall_hanging_sign": "Cartelu colgante de carbayu pálido na paré",
  "block.minecraft.pale_oak_wall_sign": "Cartelu de carbayu pálido na paré",
  "block.minecraft.pale_oak_wood": "Tochu de carbayu pálido",
  "block.minecraft.pearlescent_froglight": "Xaroncalluz nacarada",
  "block.minecraft.peony": "Peonia",
  "block.minecraft.petrified_oak_slab": "Llábana de carbayu petrificáu",
  "block.minecraft.piglin_head": "Cabeza de piglin",
  "block.minecraft.piglin_wall_head": "Cabeza de piglin na paré",
  "block.minecraft.pink_banner": "Estandarte rosa",
  "block.minecraft.pink_bed": "Cama rosa",
  "block.minecraft.pink_candle": "Vela rosa",
  "block.minecraft.pink_candle_cake": "Tarta con una vela rosa",
  "block.minecraft.pink_carpet": "Moqueta rosa",
  "block.minecraft.pink_concrete": "Formigón rosa",
  "block.minecraft.pink_concrete_powder": "Povisa de formigón rosa",
  "block.minecraft.pink_glazed_terracotta": "Azulexu rosa",
  "block.minecraft.pink_petals": "Pétalos roses",
  "block.minecraft.pink_shulker_box": "Caxa rosa de shulker",
  "block.minecraft.pink_stained_glass": "Vidru tintao en rosa",
  "block.minecraft.pink_stained_glass_pane": "Panel de vidru tintao en rosa",
  "block.minecraft.pink_terracotta": "Terracota rosa",
  "block.minecraft.pink_tulip": "Tulipán rosa",
  "block.minecraft.pink_wool": "Llana rosa",
  "block.minecraft.piston": "Pistón",
  "block.minecraft.piston_head": "Cabeza d'un pistón",
  "block.minecraft.pitcher_crop": "Cultivu de cántarus",
  "block.minecraft.pitcher_plant": "Planta de cántaros",
  "block.minecraft.player_head": "Tiesta de xugador",
  "block.minecraft.player_head.named": "Tiesta de %s",
  "block.minecraft.player_wall_head": "Tiesta de xugador na parede",
  "block.minecraft.podzol": "Llamargu",
  "block.minecraft.pointed_dripstone": "Espeleotema puntiao",
  "block.minecraft.polished_andesite": "Andesita pulío",
  "block.minecraft.polished_andesite_slab": "Llábana d'andesita pulío",
  "block.minecraft.polished_andesite_stairs": "Pasales d'andesita pulío",
  "block.minecraft.polished_basalt": "Basaltu pulío",
  "block.minecraft.polished_blackstone": "Nigrilitu pulío",
  "block.minecraft.polished_blackstone_brick_slab": "Llábana de lladriyos de nigrilitu pulío",
  "block.minecraft.polished_blackstone_brick_stairs": "Pasales de lladriyos de nigrilitu pulío",
  "block.minecraft.polished_blackstone_brick_wall": "Muria de lladriyos de nigrilitu pulío",
  "block.minecraft.polished_blackstone_bricks": "Lladriyos de nigrilitu pulío",
  "block.minecraft.polished_blackstone_button": "Botón de nigrilitu pulío",
  "block.minecraft.polished_blackstone_pressure_plate": "Placa de presión de nigrilitu pulío",
  "block.minecraft.polished_blackstone_slab": "Llábana de nigrilitu pulío",
  "block.minecraft.polished_blackstone_stairs": "Pasales de nigrilitu pulío",
  "block.minecraft.polished_blackstone_wall": "Muria de nigrilitu pulío",
  "block.minecraft.polished_deepslate": "Pizarra pulío",
  "block.minecraft.polished_deepslate_slab": "Llábana de pizarra pulío",
  "block.minecraft.polished_deepslate_stairs": "Pasales de pizarra pulío",
  "block.minecraft.polished_deepslate_wall": "Muria de pizarra pulío",
  "block.minecraft.polished_diorite": "Diorita pulío",
  "block.minecraft.polished_diorite_slab": "Llábana de diorita pulío",
  "block.minecraft.polished_diorite_stairs": "Pasales de diorita pulío",
  "block.minecraft.polished_granite": "Granitu pulío",
  "block.minecraft.polished_granite_slab": "Llábana de granitu pulío",
  "block.minecraft.polished_granite_stairs": "Pasales de granitu pulío",
  "block.minecraft.polished_tuff": "Tufu pulíu",
  "block.minecraft.polished_tuff_slab": "Solanca de tufu pulíu",
  "block.minecraft.polished_tuff_stairs": "Escaleres de tufu pulida",
  "block.minecraft.polished_tuff_wall": "Muria de tufu pulía",
  "block.minecraft.poppy": "Papola",
  "block.minecraft.potatoes": "Pataques",
  "block.minecraft.potted_acacia_sapling": "Tiestu con un biltu d'alcacia",
  "block.minecraft.potted_allium": "Tiestu con un ayu bravu",
  "block.minecraft.potted_azalea_bush": "Tiestu con rododendru",
  "block.minecraft.potted_azure_bluet": "Tiestu con una houstonia caerulea",
  "block.minecraft.potted_bamboo": "Tiestu con bambú",
  "block.minecraft.potted_birch_sapling": "Tiestu con un biltu de bidul",
  "block.minecraft.potted_blue_orchid": "Tiestu con una orquídea azul",
  "block.minecraft.potted_brown_mushroom": "Tiestu con un xampiñón",
  "block.minecraft.potted_cactus": "Tiestu con un cactus",
  "block.minecraft.potted_cherry_sapling": "Planta de cereza en maceta",
  "block.minecraft.potted_closed_eyeblossom": "Tiestu con miraflor cerrada",
  "block.minecraft.potted_cornflower": "Tiestu con una clavelina",
  "block.minecraft.potted_crimson_fungus": "Tiestu con un fungu carmesín",
  "block.minecraft.potted_crimson_roots": "Tiestu con yerba carmesín",
  "block.minecraft.potted_dandelion": "Tiestu con una xiblata",
  "block.minecraft.potted_dark_oak_sapling": "Tiestu con un biltu de carbayu escuro",
  "block.minecraft.potted_dead_bush": "Matu muertu n'unu macetu",
  "block.minecraft.potted_fern": "Tiestu con un felechu",
  "block.minecraft.potted_flowering_azalea_bush": "Tiestu con rododendru florecío",
  "block.minecraft.potted_golden_dandelion": "Potted Golden Dandelion",
  "block.minecraft.potted_jungle_sapling": "Tiestu con un biltu de la xungla",
  "block.minecraft.potted_lily_of_the_valley": "Tiestu con un lliriu de los valles",
  "block.minecraft.potted_mangrove_propagule": "Propágulu de mangle nuna maceta",
  "block.minecraft.potted_oak_sapling": "Tiestu con un biltu de carbayu",
  "block.minecraft.potted_open_eyeblossom": "Tiestu con miraflor abierta",
  "block.minecraft.potted_orange_tulip": "Tiestu con un tulipán naranxa",
  "block.minecraft.potted_oxeye_daisy": "Tiestu con un catasol grande",
  "block.minecraft.potted_pale_oak_sapling": "Tiestu con biltu de carbayu pálido",
  "block.minecraft.potted_pink_tulip": "Tiestu con un tulipán rosa",
  "block.minecraft.potted_poppy": "Tiestu con una papola",
  "block.minecraft.potted_red_mushroom": "Tiestu con un xetu roxu",
  "block.minecraft.potted_red_tulip": "Tiestu con un tulipán coloráu",
  "block.minecraft.potted_spruce_sapling": "Tiestu con un biltu d'abetu",
  "block.minecraft.potted_torchflower": "Maceta de flor de antorcha",
  "block.minecraft.potted_warped_fungus": "Tiestu con un fungu distorsionáu",
  "block.minecraft.potted_warped_roots": "Tiestu con yerba distorsionao",
  "block.minecraft.potted_white_tulip": "Tiestu con un tulipán blancu",
  "block.minecraft.potted_wither_rose": "Tiestu con una rosa de Wither",
  "block.minecraft.powder_snow": "Ñeve en polvu",
  "block.minecraft.powder_snow_cauldron": "Caldera con nieve en polvu",
  "block.minecraft.powered_rail": "Vía puxadora",
  "block.minecraft.prismarine": "Prismarín",
  "block.minecraft.prismarine_brick_slab": "Llábana de lladriyos de prismarín",
  "block.minecraft.prismarine_brick_stairs": "Pasales de lladriyos de prismarín",
  "block.minecraft.prismarine_bricks": "Lladriyos de prismarín",
  "block.minecraft.prismarine_slab": "Llábana de prismarín",
  "block.minecraft.prismarine_stairs": "Pasales de prismarín",
  "block.minecraft.prismarine_wall": "Muria de prismarín",
  "block.minecraft.pumpkin": "Calabaza",
  "block.minecraft.pumpkin_stem": "Tallu de calabaza",
  "block.minecraft.purple_banner": "Estandarte moráu",
  "block.minecraft.purple_bed": "Cama morada",
  "block.minecraft.purple_candle": "Vela morada",
  "block.minecraft.purple_candle_cake": "Tarta con una vela morada",
  "block.minecraft.purple_carpet": "Moqueta morada",
  "block.minecraft.purple_concrete": "Formigón morao",
  "block.minecraft.purple_concrete_powder": "Povisa de formigón morao",
  "block.minecraft.purple_glazed_terracotta": "Azulexu moráu",
  "block.minecraft.purple_shulker_box": "Caxa morada de shulker",
  "block.minecraft.purple_stained_glass": "Vidru tintao en morao",
  "block.minecraft.purple_stained_glass_pane": "Panel de vidru tintao en morao",
  "block.minecraft.purple_terracotta": "Terracota morao",
  "block.minecraft.purple_wool": "Llana morao",
  "block.minecraft.purpur_block": "Bloque de purpur",
  "block.minecraft.purpur_pillar": "Pilar de purpur",
  "block.minecraft.purpur_slab": "Llábana de purpur",
  "block.minecraft.purpur_stairs": "Pasales de purpur",
  "block.minecraft.quartz_block": "Bloque de cuarzu",
  "block.minecraft.quartz_bricks": "Lladriyos de cuarzu",
  "block.minecraft.quartz_pillar": "Pilar de cuarzu",
  "block.minecraft.quartz_slab": "Llábana de cuarzu",
  "block.minecraft.quartz_stairs": "Pasales de cuarzu",
  "block.minecraft.rail": "Vía",
  "block.minecraft.raw_copper_block": "Bloque de cobre en bruto",
  "block.minecraft.raw_gold_block": "Bloque d'oru en bruto",
  "block.minecraft.raw_iron_block": "Bloque de fierro en bruto",
  "block.minecraft.red_banner": "Estandarte coloráu",
  "block.minecraft.red_bed": "Cama colorada",
  "block.minecraft.red_candle": "Vela colorada",
  "block.minecraft.red_candle_cake": "Tarta con una vela colorada",
  "block.minecraft.red_carpet": "Moqueta colorada",
  "block.minecraft.red_concrete": "Formigón colorao",
  "block.minecraft.red_concrete_powder": "Povisa de formigón colorao",
  "block.minecraft.red_glazed_terracotta": "Azulexu coloráu",
  "block.minecraft.red_mushroom": "Xetu roxu",
  "block.minecraft.red_mushroom_block": "Bloque de xetos roxos",
  "block.minecraft.red_nether_brick_slab": "Llábana de lladriyos coloraos del Nether",
  "block.minecraft.red_nether_brick_stairs": "Pasales de lladriyos coloraos del Nether",
  "block.minecraft.red_nether_brick_wall": "Muria de lladriyos coloraos del Nether",
  "block.minecraft.red_nether_bricks": "Lladriyos del Nether coloraos",
  "block.minecraft.red_sand": "Sable colorao",
  "block.minecraft.red_sandstone": "Gres colorao",
  "block.minecraft.red_sandstone_slab": "Llábana de gres colorao",
  "block.minecraft.red_sandstone_stairs": "Pasales de gres colorao",
  "block.minecraft.red_sandstone_wall": "Muria de gres colorao",
  "block.minecraft.red_shulker_box": "Caxa colorada de shulker",
  "block.minecraft.red_stained_glass": "Vidru tintao en colorao",
  "block.minecraft.red_stained_glass_pane": "Panel de vidru tintao en colorao",
  "block.minecraft.red_terracotta": "Terracota colorao",
  "block.minecraft.red_tulip": "Tulipán coloráu",
  "block.minecraft.red_wool": "Llana colorao",
  "block.minecraft.redstone_block": "Bloque de redstone",
  "block.minecraft.redstone_lamp": "Llámpara de redstone",
  "block.minecraft.redstone_ore": "Veta de redstone",
  "block.minecraft.redstone_torch": "Antorcha de redstone",
  "block.minecraft.redstone_wall_torch": "Antorcha de redstone de parede",
  "block.minecraft.redstone_wire": "Cable de redstone",
  "block.minecraft.reinforced_deepslate": "Profundu fragu reinforciau",
  "block.minecraft.repeater": "Repitidor de redstone",
  "block.minecraft.repeating_command_block": "Bloque de comandos iterativu",
  "block.minecraft.resin_block": "Block of Resin",
  "block.minecraft.resin_brick_slab": "Resin Brick Slab",
  "block.minecraft.resin_brick_stairs": "Escaleres de lladriyos de resina",
  "block.minecraft.resin_brick_wall": "Resin Brick Wall",
  "block.minecraft.resin_bricks": "Resin Bricks",
  "block.minecraft.resin_clump": "Resin Clump",
  "block.minecraft.respawn_anchor": "Bloque de remanecimientu",
  "block.minecraft.rooted_dirt": "Tierra arraigonao",
  "block.minecraft.rose_bush": "Rosal",
  "block.minecraft.sand": "Sable",
  "block.minecraft.sandstone": "Gres",
  "block.minecraft.sandstone_slab": "Llábana de gres",
  "block.minecraft.sandstone_stairs": "Pasales de gres",
  "block.minecraft.sandstone_wall": "Muria de gres",
  "block.minecraft.scaffolding": "Andamiu",
  "block.minecraft.sculk": "Sculk",
  "block.minecraft.sculk_catalyst": "Catalizador sculk",
  "block.minecraft.sculk_sensor": "Sensor sculk",
  "block.minecraft.sculk_shrieker": "Glayador de Sculk",
  "block.minecraft.sculk_vein": "Vena sculk",
  "block.minecraft.sea_lantern": "Llámpara marina",
  "block.minecraft.sea_pickle": "Pirosoma",
  "block.minecraft.seagrass": "Ocle marino",
  "block.minecraft.set_spawn": "Afitóse l'aprucideru",
  "block.minecraft.short_dry_grass": "Short Dry Grass",
  "block.minecraft.short_grass": "Miera curta",
  "block.minecraft.shroomlight": "Setubril",
  "block.minecraft.shulker_box": "Caxa de shulker",
  "block.minecraft.skeleton_skull": "Craniu de Cadarma",
  "block.minecraft.skeleton_wall_skull": "Craniu na parede",
  "block.minecraft.slime_block": "Bloque de llimu",
  "block.minecraft.small_amethyst_bud": "Florecína ametista pequeño",
  "block.minecraft.small_dripleaf": "Plantaforma pequeña",
  "block.minecraft.smithing_table": "Mesa de ferrería",
  "block.minecraft.smoker": "Afumador",
  "block.minecraft.smooth_basalt": "Basaltu dondo",
  "block.minecraft.smooth_quartz": "Bloque de cuarzu dondo",
  "block.minecraft.smooth_quartz_slab": "Llábana de cuarzu dondo",
  "block.minecraft.smooth_quartz_stairs": "Pasales de cuarzu dondo",
  "block.minecraft.smooth_red_sandstone": "Gres colorao dondo",
  "block.minecraft.smooth_red_sandstone_slab": "Llábana de gres colorao dondo",
  "block.minecraft.smooth_red_sandstone_stairs": "Pasales de gres colorao dondo",
  "block.minecraft.smooth_sandstone": "Gres dondo",
  "block.minecraft.smooth_sandstone_slab": "Llábana de gres dondo",
  "block.minecraft.smooth_sandstone_stairs": "Pasales de gres dondo",
  "block.minecraft.smooth_stone": "Piedra donda",
  "block.minecraft.smooth_stone_slab": "Llábana de piedra donda",
  "block.minecraft.sniffer_egg": "Corvu d'olfatiu",
  "block.minecraft.snow": "Ñeve",
  "block.minecraft.snow_block": "Bloque de nieve",
  "block.minecraft.soul_campfire": "Foguera d'ánimes",
  "block.minecraft.soul_fire": "Fueu d'ánimes",
  "block.minecraft.soul_lantern": "Llámpara d'ánimes",
  "block.minecraft.soul_sand": "Sable d'ánimes",
  "block.minecraft.soul_soil": "Tierra d'ánimes",
  "block.minecraft.soul_torch": "Antorcha d'ánimes",
  "block.minecraft.soul_wall_torch": "Llume de muria d'almes",
  "block.minecraft.spawn.not_valid": "Non tienes cama de llar, cama de resurreición cargada o foi obstruyida",
  "block.minecraft.spawner": "Creador de monstruos",
  "block.minecraft.spawner.desc1": "Interactuar cola Güevu d'aportiu:",
  "block.minecraft.spawner.desc2": "Axusta'l tipu d'averá",
  "block.minecraft.sponge": "Esponxa",
  "block.minecraft.spore_blossom": "Flor de esporas",
  "block.minecraft.spruce_button": "Botón d'abetu",
  "block.minecraft.spruce_door": "Puerta d'abetu",
  "block.minecraft.spruce_fence": "Valla d'abetu",
  "block.minecraft.spruce_fence_gate": "Portiella d'abetu",
  "block.minecraft.spruce_hanging_sign": "Cartel colgante de abetu",
  "block.minecraft.spruce_leaves": "Fueyes d'abetu",
  "block.minecraft.spruce_log": "Tueru d'abetu",
  "block.minecraft.spruce_planks": "Tables d'abetu",
  "block.minecraft.spruce_pressure_plate": "Placa de presión d'abetu",
  "block.minecraft.spruce_sapling": "Biltu d'abetu",
  "block.minecraft.spruce_shelf": "Spruce Shelf",
  "block.minecraft.spruce_sign": "Cartelu d'abetu",
  "block.minecraft.spruce_slab": "Llábana d'abetu",
  "block.minecraft.spruce_stairs": "Pasales d'abetu",
  "block.minecraft.spruce_trapdoor": "Trapiella d'abetu",
  "block.minecraft.spruce_wall_hanging_sign": "Cartel colgante de pared de abetu",
  "block.minecraft.spruce_wall_sign": "Cartelu d'abetu na parede",
  "block.minecraft.spruce_wood": "Madera d'abetu con corteza",
  "block.minecraft.sticky_piston": "Pistón pegañón",
  "block.minecraft.stone": "Piedra",
  "block.minecraft.stone_brick_slab": "Llábana de lladriyos de piedra",
  "block.minecraft.stone_brick_stairs": "Pasales de lladriyos de piedra",
  "block.minecraft.stone_brick_wall": "Muria de lladriyos de piedra",
  "block.minecraft.stone_bricks": "Lladriyos de piedra",
  "block.minecraft.stone_button": "Botón de piedra",
  "block.minecraft.stone_pressure_plate": "Placa presión de piedra",
  "block.minecraft.stone_slab": "Llábana de piedra",
  "block.minecraft.stone_stairs": "Pasales de piedra",
  "block.minecraft.stonecutter": "Cortapiedra",
  "block.minecraft.stripped_acacia_log": "Tueru d'alcacia ensin corteza",
  "block.minecraft.stripped_acacia_wood": "Madera d'alcacia ensin corteza",
  "block.minecraft.stripped_bamboo_block": "Bloque de bambú peláu",
  "block.minecraft.stripped_birch_log": "Tueru de bidul ensin corteza",
  "block.minecraft.stripped_birch_wood": "Madera de bidul ensin corteza",
  "block.minecraft.stripped_cherry_log": "Trocín de cerru peláu",
  "block.minecraft.stripped_cherry_wood": "Madera de cerru peláu",
  "block.minecraft.stripped_crimson_hyphae": "Hífaes escarletes peladaes",
  "block.minecraft.stripped_crimson_stem": "Tueru carmesín ensin corteza",
  "block.minecraft.stripped_dark_oak_log": "Tueru de carbayu escuro ensin corteza",
  "block.minecraft.stripped_dark_oak_wood": "Madera de carbayu escuro ensin corteza",
  "block.minecraft.stripped_jungle_log": "Tueru de madera ensin corteza de la xungla",
  "block.minecraft.stripped_jungle_wood": "Madera ensin corteza de la xungla",
  "block.minecraft.stripped_mangrove_log": "Trocín de manglar peláu",
  "block.minecraft.stripped_mangrove_wood": "Madera de manglar peláu",
  "block.minecraft.stripped_oak_log": "Tueru de carbayu ensin corteza",
  "block.minecraft.stripped_oak_wood": "Madera de carbayu ensin corteza",
  "block.minecraft.stripped_pale_oak_log": "Stripped Pale Oak Log",
  "block.minecraft.stripped_pale_oak_wood": "Madera de Carbayu Pálidu Espelleyada",
  "block.minecraft.stripped_spruce_log": "Tueru d'abetu ensin corteza",
  "block.minecraft.stripped_spruce_wood": "Madera d'abetu ensin corteza",
  "block.minecraft.stripped_warped_hyphae": "Hífaes xiries peladaes",
  "block.minecraft.stripped_warped_stem": "Tueru distorsionáu ensin corteza",
  "block.minecraft.structure_block": "Bloque d'estructures",
  "block.minecraft.structure_void": "Vacíu de cadarma",
  "block.minecraft.sugar_cane": "Caña d'azucre",
  "block.minecraft.sunflower": "Xirasol",
  "block.minecraft.suspicious_gravel": "Gravilla sospechosa",
  "block.minecraft.suspicious_sand": "Arenes sospechoses",
  "block.minecraft.sweet_berry_bush": "Arbuste de berries dulces",
  "block.minecraft.tall_dry_grass": "Yerba seco alto",
  "block.minecraft.tall_grass": "Yerba alto",
  "block.minecraft.tall_seagrass": "Ocle alto",
  "block.minecraft.target": "Diana",
  "block.minecraft.terracotta": "Terracota",
  "block.minecraft.test_block": "Bloque de Prebes",
  "block.minecraft.test_instance_block": "Test Instance Block",
  "block.minecraft.tinted_glass": "Vidru tiñío",
  "block.minecraft.tnt": "TNT",
  "block.minecraft.tnt.disabled": "Les esplosiones de TNT tan desactivaes",
  "block.minecraft.torch": "Antorcha",
  "block.minecraft.torchflower": "Flor torcia",
  "block.minecraft.torchflower_crop": "Cosecha de flores de torcia",
  "block.minecraft.trapped_chest": "Bagul trampa",
  "block.minecraft.trial_spawner": "Xenerador de prueba",
  "block.minecraft.tripwire": "Cable trampa",
  "block.minecraft.tripwire_hook": "Ganchu",
  "block.minecraft.tube_coral": "Coral de tubos",
  "block.minecraft.tube_coral_block": "Bloque de coral de tubos",
  "block.minecraft.tube_coral_fan": "Gorgonia de tubos",
  "block.minecraft.tube_coral_wall_fan": "Gorgonia de tubos de parede",
  "block.minecraft.tuff": "Toba",
  "block.minecraft.tuff_brick_slab": "Llosa de lladriyos de toba",
  "block.minecraft.tuff_brick_stairs": "Pasales de Lladriyos de Toba",
  "block.minecraft.tuff_brick_wall": "Muria de Lladriyos de Toba",
  "block.minecraft.tuff_bricks": "Tuff Bricks",
  "block.minecraft.tuff_slab": "Tuff Slab",
  "block.minecraft.tuff_stairs": "Pasales de Toba",
  "block.minecraft.tuff_wall": "Muria de Toba",
  "block.minecraft.turtle_egg": "Güevu de tortuga",
  "block.minecraft.twisting_vines": "Twisting Vines",
  "block.minecraft.twisting_vines_plant": "Twisting Vines Plant",
  "block.minecraft.vault": "Arca",
  "block.minecraft.verdant_froglight": "Xaroncalluz verde",
  "block.minecraft.vine": "Enromadoriu",
  "block.minecraft.void_air": "Aire del vacíu",
  "block.minecraft.wall_torch": "Antorcha de parede",
  "block.minecraft.warped_button": "Botón distorsionáu",
  "block.minecraft.warped_door": "Puerta distorsionada",
  "block.minecraft.warped_fence": "Valla distorsionada",
  "block.minecraft.warped_fence_gate": "Portiella distorsionada",
  "block.minecraft.warped_fungus": "Fungu distorsionáu",
  "block.minecraft.warped_hanging_sign": "Cartelu colgante torcíu",
  "block.minecraft.warped_hyphae": "Hyphae torcides",
  "block.minecraft.warped_nylium": "Niliu distorsionao",
  "block.minecraft.warped_planks": "Tables distorsionaes",
  "block.minecraft.warped_pressure_plate": "Placa distorsionada de presión",
  "block.minecraft.warped_roots": "Yerba distorsionao",
  "block.minecraft.warped_shelf": "Warped Shelf",
  "block.minecraft.warped_sign": "Cartelu distorsionáu",
  "block.minecraft.warped_slab": "Llábana distorsionada",
  "block.minecraft.warped_stairs": "Pasales distorsionaos",
  "block.minecraft.warped_stem": "Madera distorsionao",
  "block.minecraft.warped_trapdoor": "Trapiella distorsionada",
  "block.minecraft.warped_wall_hanging_sign": "Cartelu colgante torcíu de pared",
  "block.minecraft.warped_wall_sign": "Cartelu de pared torcidu",
  "block.minecraft.warped_wart_block": "Bloque d'úzares distorsionaes",
  "block.minecraft.water": "Agua",
  "block.minecraft.water_cauldron": "Caldera con agua",
  "block.minecraft.waxed_chiseled_copper": "Cobre cincelado encerado",
  "block.minecraft.waxed_copper_bars": "Waxed Copper Bars",
  "block.minecraft.waxed_copper_block": "Bloque de cobre enceráu",
  "block.minecraft.waxed_copper_bulb": "Bombilla de cobre encerada",
  "block.minecraft.waxed_copper_chain": "Waxed Copper Chain",
  "block.minecraft.waxed_copper_chest": "Waxed Copper Chest",
  "block.minecraft.waxed_copper_door": "Puerta de cobre encerada",
  "block.minecraft.waxed_copper_golem_statue": "Waxed Copper Golem Statue",
  "block.minecraft.waxed_copper_grate": "Reixa de cobre encerada",
  "block.minecraft.waxed_copper_lantern": "Waxed Copper Lantern",
  "block.minecraft.waxed_copper_trapdoor": "Trampa de cobre encerada",
  "block.minecraft.waxed_cut_copper": "Cobre cortao encerao",
  "block.minecraft.waxed_cut_copper_slab": "Llábana de cobre cortao encerada",
  "block.minecraft.waxed_cut_copper_stairs": "Pasales de cobre cortao enceraos",
  "block.minecraft.waxed_exposed_chiseled_copper": "Cobre esculpiu espuesto encerado",
  "block.minecraft.waxed_exposed_copper": "Cobre al descubierto encerado",
  "block.minecraft.waxed_exposed_copper_bars": "Waxed Exposed Copper Bars",
  "block.minecraft.waxed_exposed_copper_bulb": "Bombilla de cobre al descubierto encerado",
  "block.minecraft.waxed_exposed_copper_chain": "Waxed Exposed Copper Chain",
  "block.minecraft.waxed_exposed_copper_chest": "Waxed Exposed Copper Chest",
  "block.minecraft.waxed_exposed_copper_door": "Puerta de cobre al descubierto encerado",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Waxed Exposed Copper Golem Statue",
  "block.minecraft.waxed_exposed_copper_grate": "Reja de cobre al descubierto encerada",
  "block.minecraft.waxed_exposed_copper_lantern": "Waxed Exposed Copper Lantern",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Trampilla de cobre al descubierto encerada",
  "block.minecraft.waxed_exposed_cut_copper": "Cobre expuesto cortado y encerado",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Llancha de cobre cinceláu eshomáu",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Escaleres de cobre cinceláu eshomáu",
  "block.minecraft.waxed_exposed_lightning_rod": "Waxed Exposed Lightning Rod",
  "block.minecraft.waxed_lightning_rod": "Parrayos con cera",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Cobre esfolláu oxidáu y manxáu",
  "block.minecraft.waxed_oxidized_copper": "Cobre oxidadu enceráu",
  "block.minecraft.waxed_oxidized_copper_bars": "Cadenes de cobre ferruñoso con cera",
  "block.minecraft.waxed_oxidized_copper_bulb": "Cordón de coiro oxidadu enceráu",
  "block.minecraft.waxed_oxidized_copper_chain": "Cadena de cobre ferruñoso con cera",
  "block.minecraft.waxed_oxidized_copper_chest": "Bagul de cobre ferruñoso con cera",
  "block.minecraft.waxed_oxidized_copper_door": "Porta de cobre oxidáu enceráu",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Estatua de gólem de cobre ferruñoso con cera",
  "block.minecraft.waxed_oxidized_copper_grate": "Reixu de cobre oxidáu enceráu",
  "block.minecraft.waxed_oxidized_copper_lantern": "Llámpara de cobre ferruñoso con cera",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Trampa de cobre oxidáu enceráu",
  "block.minecraft.waxed_oxidized_cut_copper": "Cobre cortáu oxidáu enceráu",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Placa d'oxídicu de cobre cortada con vierte cera",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Escaleres de cobre cortaes oxidáu y enceráu",
  "block.minecraft.waxed_oxidized_lightning_rod": "Pararrayos ferruñosu con cera",
  "block.minecraft.waxed_weathered_chiseled_copper": "Cobre chiseleáu envejecíu y enceráu",
  "block.minecraft.waxed_weathered_copper": "Cobre ensolbañado y enceráu",
  "block.minecraft.waxed_weathered_copper_bars": "Barres de cobre corroyío con cera",
  "block.minecraft.waxed_weathered_copper_bulb": "Bombilla de cobre envejecido y encerado",
  "block.minecraft.waxed_weathered_copper_chain": "Cadena de cobre corroyío con cera",
  "block.minecraft.waxed_weathered_copper_chest": "Bagul de cobre corroyío con cera",
  "block.minecraft.waxed_weathered_copper_door": "Puerta de cobre envejecido y encerado",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Estatua de gólem de cobre corroyío con cera",
  "block.minecraft.waxed_weathered_copper_grate": "Rejilla de cobre envejecido y encerado",
  "block.minecraft.waxed_weathered_copper_lantern": "Llámpara de cobre corroyío con cera",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Trampa de cobre envejecido y encerado",
  "block.minecraft.waxed_weathered_cut_copper": "Cobre cortáu envejecíu y enceráu",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Tabla de cobre cortada envejecida y encerada",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Escaleras de cobre cortado envejecido y encerado",
  "block.minecraft.waxed_weathered_lightning_rod": "Pararrayos corroyíu con cera",
  "block.minecraft.weathered_chiseled_copper": "Cobre cincelado y envejecido",
  "block.minecraft.weathered_copper": "Cobre corroyío",
  "block.minecraft.weathered_copper_bars": "Weathered Copper Bars",
  "block.minecraft.weathered_copper_bulb": "Bombilla de cobre envejecido",
  "block.minecraft.weathered_copper_chain": "Weathered Copper Chain",
  "block.minecraft.weathered_copper_chest": "Weathered Copper Chest",
  "block.minecraft.weathered_copper_door": "Puerta de cobre envejecido",
  "block.minecraft.weathered_copper_golem_statue": "Weathered Copper Golem Statue",
  "block.minecraft.weathered_copper_grate": "Reixu de cobre envejecíu",
  "block.minecraft.weathered_copper_lantern": "Weathered Copper Lantern",
  "block.minecraft.weathered_copper_trapdoor": "Portella de cobre envejecíu",
  "block.minecraft.weathered_cut_copper": "Cobre cortao corroyío",
  "block.minecraft.weathered_cut_copper_slab": "Llábana de cobre cortao corroyida",
  "block.minecraft.weathered_cut_copper_stairs": "Pasales de cobre cortao corroyíos",
  "block.minecraft.weathered_lightning_rod": "Weathered Lightning Rod",
  "block.minecraft.weeping_vines": "Lloriqueo de les plantes",
  "block.minecraft.weeping_vines_plant": "Planta de enredadera llorona",
  "block.minecraft.wet_sponge": "Esponxa moyada",
  "block.minecraft.wheat": "Collecha de trigu",
  "block.minecraft.white_banner": "Estandarte blancu",
  "block.minecraft.white_bed": "Cama blanca",
  "block.minecraft.white_candle": "Vela blanca",
  "block.minecraft.white_candle_cake": "Tarta con una vela blanca",
  "block.minecraft.white_carpet": "Moqueta blanca",
  "block.minecraft.white_concrete": "Formigón blanco",
  "block.minecraft.white_concrete_powder": "Povisa de formigón blanco",
  "block.minecraft.white_glazed_terracotta": "Azulexu blancu",
  "block.minecraft.white_shulker_box": "Caxa blanca de shulker",
  "block.minecraft.white_stained_glass": "Vidru tintao en blanco",
  "block.minecraft.white_stained_glass_pane": "Panel de vidru tintao en blanco",
  "block.minecraft.white_terracotta": "Terracota blanco",
  "block.minecraft.white_tulip": "Tulipán blancu",
  "block.minecraft.white_wool": "Llana blanco",
  "block.minecraft.wildflowers": "Flores Monteses",
  "block.minecraft.wither_rose": "Rosa de Wither",
  "block.minecraft.wither_skeleton_skull": "Craniu de wither",
  "block.minecraft.wither_skeleton_wall_skull": "Craniu de wither na parede",
  "block.minecraft.yellow_banner": "Estandarte mariellu",
  "block.minecraft.yellow_bed": "Cama mariella",
  "block.minecraft.yellow_candle": "Vela mariella",
  "block.minecraft.yellow_candle_cake": "Tarta con una vela mariella",
  "block.minecraft.yellow_carpet": "Moqueta mariella",
  "block.minecraft.yellow_concrete": "Formigón mariello",
  "block.minecraft.yellow_concrete_powder": "Povisa de formigón mariello",
  "block.minecraft.yellow_glazed_terracotta": "Azulexu mariellu",
  "block.minecraft.yellow_shulker_box": "Caxa mariella de shulker",
  "block.minecraft.yellow_stained_glass": "Vidru tintao en mariello",
  "block.minecraft.yellow_stained_glass_pane": "Panel de vidru tintao en mariello",
  "block.minecraft.yellow_terracotta": "Terracota mariello",
  "block.minecraft.yellow_wool": "Llana mariello",
  "block.minecraft.zombie_head": "Tiesta de zombi",
  "block.minecraft.zombie_wall_head": "Tiesta de zombi na parede",
  "item.minecraft.acacia_boat": "Barca d'alcacia",
  "item.minecraft.acacia_chest_boat": "Acacia Boat with Chest",
  "item.minecraft.allay_spawn_egg": "Allay Spawn Egg",
  "item.minecraft.amethyst_shard": "Cachu d'amatista",
  "item.minecraft.angler_pottery_shard": "Angler Pottery Shard",
  "item.minecraft.angler_pottery_sherd": "Angler Pottery Sherd",
  "item.minecraft.apple": "Mazana",
  "item.minecraft.archer_pottery_shard": "Archer Pottery Shard",
  "item.minecraft.archer_pottery_sherd": "Archer Pottery Sherd",
  "item.minecraft.armadillo_scute": "Escudu d'Armadillu",
  "item.minecraft.armadillo_spawn_egg": "Armadillo Spawn Egg",
  "item.minecraft.armor_stand": "Maniquín",
  "item.minecraft.arms_up_pottery_shard": "Arms Up Pottery Shard",
  "item.minecraft.arms_up_pottery_sherd": "Arms Up Pottery Sherd",
  "item.minecraft.arrow": "Flecha",
  "item.minecraft.axolotl_bucket": "Calderu con axolote",
  "item.minecraft.axolotl_spawn_egg": "Güevu qu'apruz a un axolote",
  "item.minecraft.baked_potato": "Pataca enforniada",
  "item.minecraft.bamboo_chest_raft": "Bamboo Raft with Chest",
  "item.minecraft.bamboo_raft": "Balsa de bambú",
  "item.minecraft.bat_spawn_egg": "Güevu qu'apruz a un esperteyu",
  "item.minecraft.bee_spawn_egg": "Güevu qu'apruz a una abeya",
  "item.minecraft.beef": "Chuletón crudu",
  "item.minecraft.beetroot": "Remolacha",
  "item.minecraft.beetroot_seeds": "Semiente de remolacha",
  "item.minecraft.beetroot_soup": "Sopa de remolacha",
  "item.minecraft.birch_boat": "Barca de bidul",
  "item.minecraft.birch_chest_boat": "Birch Boat with Chest",
  "item.minecraft.black_bundle": "Black Bundle",
  "item.minecraft.black_dye": "Tiñe prietu",
  "item.minecraft.black_harness": "Black Harness",
  "item.minecraft.blade_pottery_shard": "Blade Pottery Shard",
  "item.minecraft.blade_pottery_sherd": "Blade Pottery Sherd",
  "item.minecraft.blaze_powder": "Povisa d'espíritu llumiegu",
  "item.minecraft.blaze_rod": "Vara d'espíritu llumiegu",
  "item.minecraft.blaze_spawn_egg": "Güevu qu'apruz a un espíritu llumiegu",
  "item.minecraft.blue_bundle": "Blue Bundle",
  "item.minecraft.blue_dye": "Tiñe azul",
  "item.minecraft.blue_egg": "Blue Egg",
  "item.minecraft.blue_harness": "Blue Harness",
  "item.minecraft.bogged_spawn_egg": "Bogged Spawn Egg",
  "item.minecraft.bolt_armor_trim_smithing_template": "Plantiya de ferrería",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Bolt Armor Trim",
  "item.minecraft.bone": "Güesu",
  "item.minecraft.bone_meal": "Fariña óseo",
  "item.minecraft.book": "Llibru",
  "item.minecraft.bordure_indented_banner_pattern": "Bordure Indented Banner Pattern",
  "item.minecraft.bow": "Arcu",
  "item.minecraft.bowl": "Escudiella",
  "item.minecraft.bread": "Pan",
  "item.minecraft.breeze_rod": "Breeze Rod",
  "item.minecraft.breeze_spawn_egg": "Breeze Spawn Egg",
  "item.minecraft.brewer_pottery_shard": "Brewer Pottery Shard",
  "item.minecraft.brewer_pottery_sherd": "Brewer Pottery Sherd",
  "item.minecraft.brewing_stand": "Brewing Stand",
  "item.minecraft.brick": "Lladriyu",
  "item.minecraft.brown_bundle": "Brown Bundle",
  "item.minecraft.brown_dye": "Tiñe marrón",
  "item.minecraft.brown_egg": "Brown Egg",
  "item.minecraft.brown_harness": "Brown Harness",
  "item.minecraft.brush": "Cepiyu",
  "item.minecraft.bucket": "Calderu",
  "item.minecraft.bundle": "Fardela",
  "item.minecraft.bundle.empty": "Empty",
  "item.minecraft.bundle.empty.description": "Can hold a mixed stack of items",
  "item.minecraft.bundle.full": "Full",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "Burn Pottery Shard",
  "item.minecraft.burn_pottery_sherd": "Burn Pottery Sherd",
  "item.minecraft.camel_husk_spawn_egg": "Camel Husk Spawn Egg",
  "item.minecraft.camel_spawn_egg": "Camel Spawn Egg",
  "item.minecraft.carrot": "Cenahoria",
  "item.minecraft.carrot_on_a_stick": "Cenahoria nuna caña",
  "item.minecraft.cat_spawn_egg": "Güevu qu'apruz a un gatu",
  "item.minecraft.cauldron": "Cauldron",
  "item.minecraft.cave_spider_spawn_egg": "Güevu qu'apruz a una araña de cueva",
  "item.minecraft.chainmail_boots": "Botes de cota malla",
  "item.minecraft.chainmail_chestplate": "Petu de cota malla",
  "item.minecraft.chainmail_helmet": "Cascu de cota malla",
  "item.minecraft.chainmail_leggings": "Pantalones de cota malla",
  "item.minecraft.charcoal": "Carbón vexetal",
  "item.minecraft.cherry_boat": "Barcu de zrezal",
  "item.minecraft.cherry_chest_boat": "Barcu de zrezal con cofre",
  "item.minecraft.chest_minecart": "Vagoneta con un bagul",
  "item.minecraft.chicken": "Pita cruda",
  "item.minecraft.chicken_spawn_egg": "Güevu qu'apruz a una pita",
  "item.minecraft.chorus_fruit": "Fruta del Coru",
  "item.minecraft.clay_ball": "Bola de barru santo",
  "item.minecraft.clock": "Reló",
  "item.minecraft.coal": "Carbón",
  "item.minecraft.coast_armor_trim_smithing_template": "Plantiya de ferrería",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Coast Armor Trim",
  "item.minecraft.cocoa_beans": "Fabes de cacáu",
  "item.minecraft.cod": "Bacalláu crudu",
  "item.minecraft.cod_bucket": "Calderu con bacalláu",
  "item.minecraft.cod_spawn_egg": "Güevu qu'apruz a un bacalláu",
  "item.minecraft.command_block_minecart": "Vagoneta con un bloque de comandos",
  "item.minecraft.compass": "Brúxula",
  "item.minecraft.cooked_beef": "Filete",
  "item.minecraft.cooked_chicken": "Pita cocinada",
  "item.minecraft.cooked_cod": "Bacalláu cocináu",
  "item.minecraft.cooked_mutton": "Corderu cocináu",
  "item.minecraft.cooked_porkchop": "Chuleta de gochu cocinada",
  "item.minecraft.cooked_rabbit": "Coneyu cocináu",
  "item.minecraft.cooked_salmon": "Salmón cocináu",
  "item.minecraft.cookie": "Galleta",
  "item.minecraft.copper_axe": "Copper Axe",
  "item.minecraft.copper_boots": "Copper Boots",
  "item.minecraft.copper_chestplate": "Copper Chestplate",
  "item.minecraft.copper_golem_spawn_egg": "Copper Golem Spawn Egg",
  "item.minecraft.copper_helmet": "Copper Helmet",
  "item.minecraft.copper_hoe": "Copper Hoe",
  "item.minecraft.copper_horse_armor": "Copper Horse Armor",
  "item.minecraft.copper_ingot": "Llingote de cobre",
  "item.minecraft.copper_leggings": "Copper Leggings",
  "item.minecraft.copper_nautilus_armor": "Copper Nautilus Armor",
  "item.minecraft.copper_nugget": "Copper Nugget",
  "item.minecraft.copper_pickaxe": "Copper Pickaxe",
  "item.minecraft.copper_shovel": "Copper Shovel",
  "item.minecraft.copper_spear": "Copper Spear",
  "item.minecraft.copper_sword": "Copper Sword",
  "item.minecraft.cow_spawn_egg": "Güevu qu'apruz a una vaca",
  "item.minecraft.creaking_spawn_egg": "Creaking Spawn Egg",
  "item.minecraft.creeper_banner_pattern": "Patrón d'estandarte",
  "item.minecraft.creeper_banner_pattern.desc": "Dibuxu de creeper",
  "item.minecraft.creeper_banner_pattern.new": "Creeper Charge Banner Pattern",
  "item.minecraft.creeper_spawn_egg": "Güevu qu'apruz a un creeper",
  "item.minecraft.crossbow": "Ballesta",
  "item.minecraft.crossbow.projectile": "Proyeutil:",
  "item.minecraft.crossbow.projectile.multiple": "Projectile: %s x %s",
  "item.minecraft.crossbow.projectile.single": "Proyeutil: %s",
  "item.minecraft.cyan_bundle": "Cyan Bundle",
  "item.minecraft.cyan_dye": "Tiñe cianu",
  "item.minecraft.cyan_harness": "Cyan Harness",
  "item.minecraft.danger_pottery_shard": "Danger Pottery Shard",
  "item.minecraft.danger_pottery_sherd": "Danger Pottery Sherd",
  "item.minecraft.dark_oak_boat": "Barca de carbayu escuro",
  "item.minecraft.dark_oak_chest_boat": "Dark Oak Boat with Chest",
  "item.minecraft.debug_stick": "Palu de depuración",
  "item.minecraft.debug_stick.empty": "%s nun tien propiedaes",
  "item.minecraft.debug_stick.select": "selected \"%s\" (%s)",
  "item.minecraft.debug_stick.update": "«%s» camudó a %s",
  "item.minecraft.diamond": "Diamante",
  "item.minecraft.diamond_axe": "Hachu de diamante",
  "item.minecraft.diamond_boots": "Botes de diamante",
  "item.minecraft.diamond_chestplate": "Petu de diamante",
  "item.minecraft.diamond_helmet": "Cascu de diamante",
  "item.minecraft.diamond_hoe": "Fesoria de diamante",
  "item.minecraft.diamond_horse_armor": "Armadura caballuna de diamante",
  "item.minecraft.diamond_leggings": "Pantalones de diamante",
  "item.minecraft.diamond_nautilus_armor": "Diamond Nautilus Armor",
  "item.minecraft.diamond_pickaxe": "Picu de diamante",
  "item.minecraft.diamond_shovel": "Pala de diamante",
  "item.minecraft.diamond_spear": "Diamond Spear",
  "item.minecraft.diamond_sword": "Espada de diamante",
  "item.minecraft.disc_fragment_5": "Disc Fragment",
  "item.minecraft.disc_fragment_5.desc": "Vinilu - 5",
  "item.minecraft.dolphin_spawn_egg": "Güevu qu'apruz a una toliña",
  "item.minecraft.donkey_spawn_egg": "Güevu qu'apruz a un pollín",
  "item.minecraft.dragon_breath": "Frascu con aliendu de cuélebre",
  "item.minecraft.dried_kelp": "Laminarial seco",
  "item.minecraft.drowned_spawn_egg": "Güevu qu'apruz a un afogáu",
  "item.minecraft.dune_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Dune Armor Trim",
  "item.minecraft.echo_shard": "Fragmentu d'ecu",
  "item.minecraft.egg": "Güevu",
  "item.minecraft.elder_guardian_spawn_egg": "Güevu qu'apruz a un guardián vieyu",
  "item.minecraft.elytra": "Élitru",
  "item.minecraft.emerald": "Esmeralda",
  "item.minecraft.enchanted_book": "Llibru encantexáu",
  "item.minecraft.enchanted_golden_apple": "Mazana d'oru encantexada",
  "item.minecraft.end_crystal": "Cristal del End",
  "item.minecraft.ender_dragon_spawn_egg": "Ender Dragon Spawn Egg",
  "item.minecraft.ender_eye": "Güeyu d'Ender",
  "item.minecraft.ender_pearl": "Perlla d'Ender",
  "item.minecraft.enderman_spawn_egg": "Güevu qu'apruz a un enderman",
  "item.minecraft.endermite_spawn_egg": "Güevu qu'apruz a un endermite",
  "item.minecraft.evoker_spawn_egg": "Güevu qu'apruz a un evocador",
  "item.minecraft.experience_bottle": "Botella encantexada",
  "item.minecraft.explorer_pottery_shard": "Explorer Pottery Shard",
  "item.minecraft.explorer_pottery_sherd": "Explorer Pottery Sherd",
  "item.minecraft.eye_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Eye Armor Trim",
  "item.minecraft.feather": "Pluma",
  "item.minecraft.fermented_spider_eye": "Güeyu d'araña formentáu",
  "item.minecraft.field_masoned_banner_pattern": "Field Masoned Banner Pattern",
  "item.minecraft.filled_map": "Mapa",
  "item.minecraft.fire_charge": "Carga de fueu",
  "item.minecraft.firework_rocket": "Volador",
  "item.minecraft.firework_rocket.flight": "Duración del vuelu:",
  "item.minecraft.firework_rocket.multiple_stars": "%s x %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Volador d'estrella",
  "item.minecraft.firework_star.black": "Prietu",
  "item.minecraft.firework_star.blue": "Azul",
  "item.minecraft.firework_star.brown": "Marrón",
  "item.minecraft.firework_star.custom_color": "Custom",
  "item.minecraft.firework_star.cyan": "Cianu",
  "item.minecraft.firework_star.fade_to": "Esvanez a",
  "item.minecraft.firework_star.flicker": "Relluz",
  "item.minecraft.firework_star.gray": "Buxu",
  "item.minecraft.firework_star.green": "Verde",
  "item.minecraft.firework_star.light_blue": "Azul claro",
  "item.minecraft.firework_star.light_gray": "Buxu claro",
  "item.minecraft.firework_star.lime": "Llima",
  "item.minecraft.firework_star.magenta": "Maxenta",
  "item.minecraft.firework_star.orange": "Naranxa",
  "item.minecraft.firework_star.pink": "Rosa",
  "item.minecraft.firework_star.purple": "Moráu",
  "item.minecraft.firework_star.red": "Coloráu",
  "item.minecraft.firework_star.shape": "Forma desconocida",
  "item.minecraft.firework_star.shape.burst": "Con españíu",
  "item.minecraft.firework_star.shape.creeper": "En forma de Creeper",
  "item.minecraft.firework_star.shape.large_ball": "Bola grande",
  "item.minecraft.firework_star.shape.small_ball": "Bola pequeña",
  "item.minecraft.firework_star.shape.star": "En forma d'estrella",
  "item.minecraft.firework_star.trail": "Dexa rastru",
  "item.minecraft.firework_star.white": "Blancu",
  "item.minecraft.firework_star.yellow": "Mariellu",
  "item.minecraft.fishing_rod": "Caña de pescar",
  "item.minecraft.flint": "Ferrial",
  "item.minecraft.flint_and_steel": "Chisqueru",
  "item.minecraft.flow_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Flow Armor Trim",
  "item.minecraft.flow_banner_pattern": "Banner Pattern",
  "item.minecraft.flow_banner_pattern.desc": "Flow",
  "item.minecraft.flow_banner_pattern.new": "Flow Banner Pattern",
  "item.minecraft.flow_pottery_sherd": "Flow Pottery Sherd",
  "item.minecraft.flower_banner_pattern": "Banner Pattern",
  "item.minecraft.flower_banner_pattern.desc": "Dibuxu de flor",
  "item.minecraft.flower_banner_pattern.new": "Flower Charge Banner Pattern",
  "item.minecraft.flower_pot": "Flower Pot",
  "item.minecraft.fox_spawn_egg": "Güevu qu'apruz a un raposu",
  "item.minecraft.friend_pottery_shard": "Friend Pottery Shard",
  "item.minecraft.friend_pottery_sherd": "Friend Pottery Sherd",
  "item.minecraft.frog_spawn_egg": "Frog Spawn Egg",
  "item.minecraft.furnace_minecart": "Vagoneta con un fornu",
  "item.minecraft.ghast_spawn_egg": "Güevu qu'apruz a un ghast",
  "item.minecraft.ghast_tear": "Llárima de ghast",
  "item.minecraft.glass_bottle": "Frascu",
  "item.minecraft.glistering_melon_slice": "Cachu de sandía rellumante",
  "item.minecraft.globe_banner_pattern": "Banner Pattern",
  "item.minecraft.globe_banner_pattern.desc": "Planeta",
  "item.minecraft.globe_banner_pattern.new": "Globe Banner Pattern",
  "item.minecraft.glow_berries": "Bagues dulces rellumantes",
  "item.minecraft.glow_ink_sac": "Sacu de tinta rellumante",
  "item.minecraft.glow_item_frame": "Glow Item Frame",
  "item.minecraft.glow_squid_spawn_egg": "Güevu qu'apruz a un calamar rellumante",
  "item.minecraft.glowstone_dust": "Povisa de piedra rellumante",
  "item.minecraft.goat_horn": "Cuernu de cabra",
  "item.minecraft.goat_spawn_egg": "Güevu qu'apruz a una cabra",
  "item.minecraft.gold_ingot": "Llingote d'oru",
  "item.minecraft.gold_nugget": "Llixu d'oru",
  "item.minecraft.golden_apple": "Mazana d'oru",
  "item.minecraft.golden_axe": "Hachu d'oru",
  "item.minecraft.golden_boots": "Botes d'oru",
  "item.minecraft.golden_carrot": "Cenahoria d'oru",
  "item.minecraft.golden_chestplate": "Petu d'oru",
  "item.minecraft.golden_helmet": "Cascu d'oru",
  "item.minecraft.golden_hoe": "Fesoria d'oru",
  "item.minecraft.golden_horse_armor": "Armadura caballuna d'oru",
  "item.minecraft.golden_leggings": "Pantalones d'oru",
  "item.minecraft.golden_nautilus_armor": "Golden Nautilus Armor",
  "item.minecraft.golden_pickaxe": "Picu d'oru",
  "item.minecraft.golden_shovel": "Pala d'oru",
  "item.minecraft.golden_spear": "Golden Spear",
  "item.minecraft.golden_sword": "Espada d'oru",
  "item.minecraft.gray_bundle": "Gray Bundle",
  "item.minecraft.gray_dye": "Tiñe buxu",
  "item.minecraft.gray_harness": "Gray Harness",
  "item.minecraft.green_bundle": "Green Bundle",
  "item.minecraft.green_dye": "Tiñe verde",
  "item.minecraft.green_harness": "Green Harness",
  "item.minecraft.guardian_spawn_egg": "Güevu qu'apruz a un guardián",
  "item.minecraft.gunpowder": "Pólvora",
  "item.minecraft.guster_banner_pattern": "Banner Pattern",
  "item.minecraft.guster_banner_pattern.desc": "Guster",
  "item.minecraft.guster_banner_pattern.new": "Guster Banner Pattern",
  "item.minecraft.guster_pottery_sherd": "Guster Pottery Sherd",
  "item.minecraft.happy_ghast_spawn_egg": "Happy Ghast Spawn Egg",
  "item.minecraft.harness": "Harness",
  "item.minecraft.heart_of_the_sea": "Corazón de la mar",
  "item.minecraft.heart_pottery_shard": "Heart Pottery Shard",
  "item.minecraft.heart_pottery_sherd": "Heart Pottery Sherd",
  "item.minecraft.heartbreak_pottery_shard": "Heartbreak Pottery Shard",
  "item.minecraft.heartbreak_pottery_sherd": "Heartbreak Pottery Sherd",
  "item.minecraft.hoglin_spawn_egg": "Güevu qu'apruz a un hoglin",
  "item.minecraft.honey_bottle": "Frascu con miel",
  "item.minecraft.honeycomb": "Caxellar",
  "item.minecraft.hopper_minecart": "Vagoneta con embudu",
  "item.minecraft.horse_spawn_egg": "Güevu qu'apruz a un caballu",
  "item.minecraft.host_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.host_armor_trim_smithing_template.new": "Host Armor Trim",
  "item.minecraft.howl_pottery_shard": "Howl Pottery Shard",
  "item.minecraft.howl_pottery_sherd": "Howl Pottery Sherd",
  "item.minecraft.husk_spawn_egg": "Güevu qu'apruz a una momia",
  "item.minecraft.ink_sac": "Sacu de tinta",
  "item.minecraft.iron_axe": "Hachu de fierro",
  "item.minecraft.iron_boots": "Botes de fierro",
  "item.minecraft.iron_chestplate": "Petu de fierro",
  "item.minecraft.iron_golem_spawn_egg": "Iron Golem Spawn Egg",
  "item.minecraft.iron_helmet": "Cascu de fierro",
  "item.minecraft.iron_hoe": "Fesoria de fierro",
  "item.minecraft.iron_horse_armor": "Armadura caballuna de fierro",
  "item.minecraft.iron_ingot": "Llingote de fierro",
  "item.minecraft.iron_leggings": "Pantalones de fierro",
  "item.minecraft.iron_nautilus_armor": "Iron Nautilus Armor",
  "item.minecraft.iron_nugget": "Llixu de fierro",
  "item.minecraft.iron_pickaxe": "Picu de fierro",
  "item.minecraft.iron_shovel": "Pala de fierro",
  "item.minecraft.iron_spear": "Iron Spear",
  "item.minecraft.iron_sword": "Espada de fierro",
  "item.minecraft.item_frame": "Marcu d'oxetos",
  "item.minecraft.jungle_boat": "Barca de madera de la xungla",
  "item.minecraft.jungle_chest_boat": "Jungle Boat with Chest",
  "item.minecraft.knowledge_book": "Llibru de conocencia",
  "item.minecraft.lapis_lazuli": "Llapislázuli",
  "item.minecraft.lava_bucket": "Calderu con llava",
  "item.minecraft.lead": "Llaciu",
  "item.minecraft.leather": "Cueru",
  "item.minecraft.leather_boots": "Botes de cueru",
  "item.minecraft.leather_chestplate": "Túnica de cueru",
  "item.minecraft.leather_helmet": "Cascu de cueru",
  "item.minecraft.leather_horse_armor": "Leather Horse Armor",
  "item.minecraft.leather_leggings": "Pantalones de cueru",
  "item.minecraft.light_blue_bundle": "Light Blue Bundle",
  "item.minecraft.light_blue_dye": "Tiñe azul claro",
  "item.minecraft.light_blue_harness": "Light Blue Harness",
  "item.minecraft.light_gray_bundle": "Light Gray Bundle",
  "item.minecraft.light_gray_dye": "Tiñe buxu claro",
  "item.minecraft.light_gray_harness": "Light Gray Harness",
  "item.minecraft.lime_bundle": "Lime Bundle",
  "item.minecraft.lime_dye": "Tiñe llima",
  "item.minecraft.lime_harness": "Lime Harness",
  "item.minecraft.lingering_potion": "Brebaxe prollongáu",
  "item.minecraft.lingering_potion.effect.awkward": "Brebaxe prollongáu raru",
  "item.minecraft.lingering_potion.effect.empty": "Brebaxe prollongáu non ellaborable",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Brebaxe prollongáu de resistencia al fueu",
  "item.minecraft.lingering_potion.effect.harming": "Brebaxe prollongáu de dañu",
  "item.minecraft.lingering_potion.effect.healing": "Brebaxe prollongáu de curación",
  "item.minecraft.lingering_potion.effect.infested": "Lingering Potion of Infestation",
  "item.minecraft.lingering_potion.effect.invisibility": "Brebaxe prollongáu d'invisibilidá",
  "item.minecraft.lingering_potion.effect.leaping": "Brebaxe prollongáu de blincu",
  "item.minecraft.lingering_potion.effect.levitation": "Brebaxe prollongáu de llevitación",
  "item.minecraft.lingering_potion.effect.luck": "Brebaxe prollongáu de suerte",
  "item.minecraft.lingering_potion.effect.mundane": "Brebaxe vulgar prollongáu",
  "item.minecraft.lingering_potion.effect.night_vision": "Brebaxe prollongáu de visión nocherniego",
  "item.minecraft.lingering_potion.effect.oozing": "Lingering Potion of Oozing",
  "item.minecraft.lingering_potion.effect.poison": "Brebaxe prollongáu de velenu",
  "item.minecraft.lingering_potion.effect.regeneration": "Brebaxe prollongáu de rexeneración",
  "item.minecraft.lingering_potion.effect.slow_falling": "Brebaxe prollongáu de cayida lenta",
  "item.minecraft.lingering_potion.effect.slowness": "Brebaxe prollongáu de lentitú",
  "item.minecraft.lingering_potion.effect.strength": "Brebaxe prollongáu de fuercia",
  "item.minecraft.lingering_potion.effect.swiftness": "Brebaxe prollongáu de rapidez",
  "item.minecraft.lingering_potion.effect.thick": "Brebaxe prollongáu espesu",
  "item.minecraft.lingering_potion.effect.turtle_master": "Brebaxe prollongáu del maestru de tortugues",
  "item.minecraft.lingering_potion.effect.water": "Frascu prollongáu con agua",
  "item.minecraft.lingering_potion.effect.water_breathing": "Brebaxe prollongáu d'aliendu acuáticu",
  "item.minecraft.lingering_potion.effect.weakness": "Brebaxe prollongáu de badea",
  "item.minecraft.lingering_potion.effect.weaving": "Lingering Potion of Weaving",
  "item.minecraft.lingering_potion.effect.wind_charged": "Lingering Potion of Wind Charging",
  "item.minecraft.llama_spawn_egg": "Güevu qu'apruz a una llama",
  "item.minecraft.lodestone_compass": "Brúxula imantada",
  "item.minecraft.mace": "Mace",
  "item.minecraft.magenta_bundle": "Magenta Bundle",
  "item.minecraft.magenta_dye": "Tiñe maxenta",
  "item.minecraft.magenta_harness": "Magenta Harness",
  "item.minecraft.magma_cream": "Crema magmática",
  "item.minecraft.magma_cube_spawn_egg": "Güevu qu'apruz a un llimu magmáticu",
  "item.minecraft.mangrove_boat": "Mangrove Boat",
  "item.minecraft.mangrove_chest_boat": "Mangrove Boat with Chest",
  "item.minecraft.map": "Mapa baleru",
  "item.minecraft.melon_seeds": "Semiente de sandía",
  "item.minecraft.melon_slice": "Cachu de sandía",
  "item.minecraft.milk_bucket": "Calderu con lleche",
  "item.minecraft.minecart": "Vagoneta",
  "item.minecraft.miner_pottery_shard": "Miner Pottery Shard",
  "item.minecraft.miner_pottery_sherd": "Miner Pottery Sherd",
  "item.minecraft.mojang_banner_pattern": "Banner Pattern",
  "item.minecraft.mojang_banner_pattern.desc": "Llogotipu",
  "item.minecraft.mojang_banner_pattern.new": "Thing Banner Pattern",
  "item.minecraft.mooshroom_spawn_egg": "Güevu qu'apruz a un mooshroom",
  "item.minecraft.mourner_pottery_shard": "Mourner Pottery Shard",
  "item.minecraft.mourner_pottery_sherd": "Mourner Pottery Sherd",
  "item.minecraft.mule_spawn_egg": "Güevu qu'apruz a una mula",
  "item.minecraft.mushroom_stew": "Guisu de fungu",
  "item.minecraft.music_disc_11": "Vinilu",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "Vinilu",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "Vinilu",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg - 5",
  "item.minecraft.music_disc_blocks": "Vinilu",
  "item.minecraft.music_disc_blocks.desc": "C418 - blocks",
  "item.minecraft.music_disc_cat": "Vinilu",
  "item.minecraft.music_disc_cat.desc": "C418 - cat",
  "item.minecraft.music_disc_chirp": "Vinilu",
  "item.minecraft.music_disc_chirp.desc": "C418 - chirp",
  "item.minecraft.music_disc_creator": "Vinilu",
  "item.minecraft.music_disc_creator.desc": "Lena Raine - Creator",
  "item.minecraft.music_disc_creator_music_box": "Vinilu",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine - Creator (Music Box)",
  "item.minecraft.music_disc_far": "Vinilu",
  "item.minecraft.music_disc_far.desc": "C418 - far",
  "item.minecraft.music_disc_lava_chicken": "Vinilu",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions - Lava Chicken",
  "item.minecraft.music_disc_mall": "Vinilu",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "Vinilu",
  "item.minecraft.music_disc_mellohi.desc": "C418 - mellohi",
  "item.minecraft.music_disc_otherside": "Vinilu",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine - otherside",
  "item.minecraft.music_disc_pigstep": "Vinilu",
  "item.minecraft.music_disc_pigstep.desc": "Lena Raine - Pigstep",
  "item.minecraft.music_disc_precipice": "Vinilu",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof - Precipice",
  "item.minecraft.music_disc_relic": "Vinilu",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof - Relic",
  "item.minecraft.music_disc_stal": "Vinilu",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "Vinilu",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "Vinilu",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy - Tears",
  "item.minecraft.music_disc_wait": "Vinilu",
  "item.minecraft.music_disc_wait.desc": "C418 - wait",
  "item.minecraft.music_disc_ward": "Vinilu",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "Corderu crudu",
  "item.minecraft.name_tag": "Etiqueta",
  "item.minecraft.nautilus_shell": "Cascu de nautilu",
  "item.minecraft.nautilus_spawn_egg": "Nautilus Spawn Egg",
  "item.minecraft.nether_brick": "Lladriyu del Nether",
  "item.minecraft.nether_star": "Estrella del Nether",
  "item.minecraft.nether_wart": "Nether Wart",
  "item.minecraft.netherite_axe": "Hachu de netherita",
  "item.minecraft.netherite_boots": "Botes de netherita",
  "item.minecraft.netherite_chestplate": "Petu de netherita",
  "item.minecraft.netherite_helmet": "Cascu de netherita",
  "item.minecraft.netherite_hoe": "Fesoria de netherita",
  "item.minecraft.netherite_horse_armor": "Netherite Horse Armor",
  "item.minecraft.netherite_ingot": "Llingote de netherita",
  "item.minecraft.netherite_leggings": "Pantalones de netherita",
  "item.minecraft.netherite_nautilus_armor": "Netherite Nautilus Armor",
  "item.minecraft.netherite_pickaxe": "Picu de netherita",
  "item.minecraft.netherite_scrap": "Escoria de netherita",
  "item.minecraft.netherite_shovel": "Pala de netherita",
  "item.minecraft.netherite_spear": "Netherite Spear",
  "item.minecraft.netherite_sword": "Espada de netherita",
  "item.minecraft.netherite_upgrade_smithing_template": "Smithing Template",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Netherite Upgrade",
  "item.minecraft.oak_boat": "Barca de carbayu",
  "item.minecraft.oak_chest_boat": "Oak Boat with Chest",
  "item.minecraft.ocelot_spawn_egg": "Güevu qu'apruz a un ocelote",
  "item.minecraft.ominous_bottle": "Ominous Bottle",
  "item.minecraft.ominous_trial_key": "Ominous Trial Key",
  "item.minecraft.orange_bundle": "Orange Bundle",
  "item.minecraft.orange_dye": "Tiñe naranxa",
  "item.minecraft.orange_harness": "Orange Harness",
  "item.minecraft.painting": "Cuadru",
  "item.minecraft.pale_oak_boat": "Pale Oak Boat",
  "item.minecraft.pale_oak_chest_boat": "Pale Oak Boat with Chest",
  "item.minecraft.panda_spawn_egg": "Güevu qu'apruz a un panda",
  "item.minecraft.paper": "Papel",
  "item.minecraft.parched_spawn_egg": "Parched Spawn Egg",
  "item.minecraft.parrot_spawn_egg": "Güevu qu'apruz a un loru",
  "item.minecraft.phantom_membrane": "Membrana de pantasma",
  "item.minecraft.phantom_spawn_egg": "Güevu qu'apruz a un pantasma",
  "item.minecraft.pig_spawn_egg": "Güevu qu'apruz a un gochu",
  "item.minecraft.piglin_banner_pattern": "Patrón d'estandarte",
  "item.minecraft.piglin_banner_pattern.desc": "Focicu",
  "item.minecraft.piglin_banner_pattern.new": "Patrón d'estandarte de focicu",
  "item.minecraft.piglin_brute_spawn_egg": "Güevu qu'apruz un piglin brutu",
  "item.minecraft.piglin_spawn_egg": "Güevu qu'apruz a un piglin",
  "item.minecraft.pillager_spawn_egg": "Güevu qu'apruz a un saquiador",
  "item.minecraft.pink_bundle": "Pink Bundle",
  "item.minecraft.pink_dye": "Tiñe rosa",
  "item.minecraft.pink_harness": "Pink Harness",
  "item.minecraft.pitcher_plant": "Pitcher Plant",
  "item.minecraft.pitcher_pod": "Pitcher Pod",
  "item.minecraft.plenty_pottery_shard": "Plenty Pottery Shard",
  "item.minecraft.plenty_pottery_sherd": "Plenty Pottery Sherd",
  "item.minecraft.poisonous_potato": "Pataca velenosa",
  "item.minecraft.polar_bear_spawn_egg": "Güevu qu'apruz a un osu polar",
  "item.minecraft.popped_chorus_fruit": "Fruta del Coru cocinada",
  "item.minecraft.porkchop": "Chuleta de gochu cruda",
  "item.minecraft.potato": "Pataca",
  "item.minecraft.potion": "Brebaxe",
  "item.minecraft.potion.effect.awkward": "Brebaxe raru",
  "item.minecraft.potion.effect.empty": "Brebaxe non ellaborable",
  "item.minecraft.potion.effect.fire_resistance": "Brebaxe de resistencia al fueu",
  "item.minecraft.potion.effect.harming": "Brebaxe de dañu",
  "item.minecraft.potion.effect.healing": "Brebaxe de curación",
  "item.minecraft.potion.effect.infested": "Potion of Infestation",
  "item.minecraft.potion.effect.invisibility": "Brebaxe d'invisibilidá",
  "item.minecraft.potion.effect.leaping": "Brebaxe de blincu",
  "item.minecraft.potion.effect.levitation": "Brebaxe de llevitación",
  "item.minecraft.potion.effect.luck": "Brebaxe de suerte",
  "item.minecraft.potion.effect.mundane": "Brebaxe vulgar",
  "item.minecraft.potion.effect.night_vision": "Brebaxe de visión nocherniego",
  "item.minecraft.potion.effect.oozing": "Potion of Oozing",
  "item.minecraft.potion.effect.poison": "Brebaxe de velenu",
  "item.minecraft.potion.effect.regeneration": "Brebaxe de rexeneración",
  "item.minecraft.potion.effect.slow_falling": "Brebaxe de cayida lenta",
  "item.minecraft.potion.effect.slowness": "Brebaxe de lentitú",
  "item.minecraft.potion.effect.strength": "Brebaxe de fuercia",
  "item.minecraft.potion.effect.swiftness": "Brebaxe de rapidez",
  "item.minecraft.potion.effect.thick": "Brebaxe espesu",
  "item.minecraft.potion.effect.turtle_master": "Brebaxe del maestru de tortugues",
  "item.minecraft.potion.effect.water": "Frascu d'agua",
  "item.minecraft.potion.effect.water_breathing": "Brebaxe d'aliendu acuáticu",
  "item.minecraft.potion.effect.weakness": "Brebaxe de badea",
  "item.minecraft.potion.effect.weaving": "Potion of Weaving",
  "item.minecraft.potion.effect.wind_charged": "Potion of Wind Charging",
  "item.minecraft.pottery_shard_archer": "Archer Pottery Shard",
  "item.minecraft.pottery_shard_arms_up": "Arms Up Pottery Shard",
  "item.minecraft.pottery_shard_prize": "Prize Pottery Shard",
  "item.minecraft.pottery_shard_skull": "Skull Pottery Shard",
  "item.minecraft.powder_snow_bucket": "Powder Snow Bucket",
  "item.minecraft.prismarine_crystals": "Cristales de prismarín",
  "item.minecraft.prismarine_shard": "Cachu de prismarín",
  "item.minecraft.prize_pottery_shard": "Prize Pottery Shard",
  "item.minecraft.prize_pottery_sherd": "Prize Pottery Sherd",
  "item.minecraft.pufferfish": "Pexe globu",
  "item.minecraft.pufferfish_bucket": "Calderu con pexe globu",
  "item.minecraft.pufferfish_spawn_egg": "Güevu qu'apruz a un pexe globu",
  "item.minecraft.pumpkin_pie": "Pastel de calabaza",
  "item.minecraft.pumpkin_seeds": "Semiente de calabaza",
  "item.minecraft.purple_bundle": "Sacu moráu",
  "item.minecraft.purple_dye": "Tiñe moráu",
  "item.minecraft.purple_harness": "Purple Harness",
  "item.minecraft.quartz": "Cuarzu del Nether",
  "item.minecraft.rabbit": "Coneyu crudu",
  "item.minecraft.rabbit_foot": "Pie de coneyu",
  "item.minecraft.rabbit_hide": "Pelleyu de coneyu",
  "item.minecraft.rabbit_spawn_egg": "Güevu qu'apruz a un coneyu",
  "item.minecraft.rabbit_stew": "Guisu de coneyu",
  "item.minecraft.raiser_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Raiser Armor Trim",
  "item.minecraft.ravager_spawn_egg": "Güevu qu'apruz a un afarador",
  "item.minecraft.raw_copper": "Cobre en bruto",
  "item.minecraft.raw_gold": "Oru en bruto",
  "item.minecraft.raw_iron": "Fierro en bruto",
  "item.minecraft.recovery_compass": "Recovery Compass",
  "item.minecraft.red_bundle": "Red Bundle",
  "item.minecraft.red_dye": "Tiñe coloráu",
  "item.minecraft.red_harness": "Red Harness",
  "item.minecraft.redstone": "Povisa de redstone",
  "item.minecraft.resin_brick": "Resin Brick",
  "item.minecraft.resin_clump": "Resin Clump",
  "item.minecraft.rib_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Rib Armor Trim",
  "item.minecraft.rotten_flesh": "Carne apodrecío",
  "item.minecraft.saddle": "Sillín",
  "item.minecraft.salmon": "Salmón crudu",
  "item.minecraft.salmon_bucket": "Calderu con salmón",
  "item.minecraft.salmon_spawn_egg": "Güevu qu'apruz a un salmón",
  "item.minecraft.scrape_pottery_sherd": "Scrape Pottery Sherd",
  "item.minecraft.scute": "Escudu",
  "item.minecraft.sentry_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Sentry Armor Trim",
  "item.minecraft.shaper_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Shaper Armor Trim",
  "item.minecraft.sheaf_pottery_shard": "Sheaf Pottery Shard",
  "item.minecraft.sheaf_pottery_sherd": "Sheaf Pottery Sherd",
  "item.minecraft.shears": "Tisoria",
  "item.minecraft.sheep_spawn_egg": "Güevu qu'apruz a una oveya",
  "item.minecraft.shelter_pottery_shard": "Shelter Pottery Shard",
  "item.minecraft.shelter_pottery_sherd": "Shelter Pottery Sherd",
  "item.minecraft.shield": "Escudu",
  "item.minecraft.shield.black": "Escudu prietu",
  "item.minecraft.shield.blue": "Escudu azul",
  "item.minecraft.shield.brown": "Escudu marrón",
  "item.minecraft.shield.cyan": "Escudu cianu",
  "item.minecraft.shield.gray": "Escudu buxu",
  "item.minecraft.shield.green": "Escudu verde",
  "item.minecraft.shield.light_blue": "Escudu azul claro",
  "item.minecraft.shield.light_gray": "Escudu buxu claro",
  "item.minecraft.shield.lime": "Escudu llima",
  "item.minecraft.shield.magenta": "Escudu maxenta",
  "item.minecraft.shield.orange": "Escudu naranxa",
  "item.minecraft.shield.pink": "Escudu rosa",
  "item.minecraft.shield.purple": "Escudu moráu",
  "item.minecraft.shield.red": "Escudu coloráu",
  "item.minecraft.shield.white": "Escudu blancu",
  "item.minecraft.shield.yellow": "Escudu mariellu",
  "item.minecraft.shulker_shell": "Cascu de shulker",
  "item.minecraft.shulker_spawn_egg": "Güevu qu'apruz a un shulker",
  "item.minecraft.sign": "Lletreru",
  "item.minecraft.silence_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Silence Armor Trim",
  "item.minecraft.silverfish_spawn_egg": "Güevu qu'apruz a una xibiella",
  "item.minecraft.skeleton_horse_spawn_egg": "Güevu qu'apruz a un caballu esqueléticu",
  "item.minecraft.skeleton_spawn_egg": "Güevu qu'apruz a una cadarma",
  "item.minecraft.skull_banner_pattern": "Banner Pattern",
  "item.minecraft.skull_banner_pattern.desc": "Dibuxu de craniu",
  "item.minecraft.skull_banner_pattern.new": "Skull Charge Banner Pattern",
  "item.minecraft.skull_pottery_shard": "Skull Pottery Shard",
  "item.minecraft.skull_pottery_sherd": "Skull Pottery Sherd",
  "item.minecraft.slime_ball": "Bola de llimu",
  "item.minecraft.slime_spawn_egg": "Güevu qu'apruz a un llimu",
  "item.minecraft.smithing_template": "Smithing Template",
  "item.minecraft.smithing_template.applies_to": "Aplícase a:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Añede un llingote o cristal",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Armadura",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Añede una pieza d'armadura",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Llingotes y cristales",
  "item.minecraft.smithing_template.ingredients": "Ingredientes:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Añede llingote de netherita",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Equipamientu de diamante",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Añede una armadura, arma o ferramienta de diamante",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Llingote de netherita",
  "item.minecraft.smithing_template.upgrade": "Meyora: ",
  "item.minecraft.sniffer_spawn_egg": "Sniffer Spawn Egg",
  "item.minecraft.snort_pottery_shard": "Snort Pottery Shard",
  "item.minecraft.snort_pottery_sherd": "Snort Pottery Sherd",
  "item.minecraft.snout_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Snout Armor Trim",
  "item.minecraft.snow_golem_spawn_egg": "Snow Golem Spawn Egg",
  "item.minecraft.snowball": "Pella",
  "item.minecraft.spectral_arrow": "Flecha espectral",
  "item.minecraft.spider_eye": "Güeyu d'araña",
  "item.minecraft.spider_spawn_egg": "Güevu qu'apruz a una araña",
  "item.minecraft.spire_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Spire Armor Trim",
  "item.minecraft.splash_potion": "Brebaxe refundizu",
  "item.minecraft.splash_potion.effect.awkward": "Brebaxe refundizu raru",
  "item.minecraft.splash_potion.effect.empty": "Brebaxe refundizu non ellaborable",
  "item.minecraft.splash_potion.effect.fire_resistance": "Brebaxe refundizu de resistencia al fueu",
  "item.minecraft.splash_potion.effect.harming": "Brebaxe refundizu de dañu",
  "item.minecraft.splash_potion.effect.healing": "Brebaxe refundizu de curación",
  "item.minecraft.splash_potion.effect.infested": "Splash Potion of Infestation",
  "item.minecraft.splash_potion.effect.invisibility": "Brebaxe refundizu d'invisibilidá",
  "item.minecraft.splash_potion.effect.leaping": "Brebaxe refundizu de blincu",
  "item.minecraft.splash_potion.effect.levitation": "Brebaxe refundizu de llevitación",
  "item.minecraft.splash_potion.effect.luck": "Brebaxe refundizu de suerte",
  "item.minecraft.splash_potion.effect.mundane": "Brebaxe vulgar refundizu",
  "item.minecraft.splash_potion.effect.night_vision": "Brebaxe refundizu de visión nocherniego",
  "item.minecraft.splash_potion.effect.oozing": "Splash Potion of Oozing",
  "item.minecraft.splash_potion.effect.poison": "Brebaxe refundizu de velenu",
  "item.minecraft.splash_potion.effect.regeneration": "Brebaxe refundizu de rexeneración",
  "item.minecraft.splash_potion.effect.slow_falling": "Brebaxe refundizu de cayida lenta",
  "item.minecraft.splash_potion.effect.slowness": "Brebaxe refundizu de lentitú",
  "item.minecraft.splash_potion.effect.strength": "Brebaxe refundizu de fuercia",
  "item.minecraft.splash_potion.effect.swiftness": "Brebaxe refundizu de rapidez",
  "item.minecraft.splash_potion.effect.thick": "Brebaxe espesu refundizu",
  "item.minecraft.splash_potion.effect.turtle_master": "Brebaxe refundizu del maestru de tortugues",
  "item.minecraft.splash_potion.effect.water": "Frascu refundizu con agua",
  "item.minecraft.splash_potion.effect.water_breathing": "Brebaxe refundizu d'aliendu acuáticu",
  "item.minecraft.splash_potion.effect.weakness": "Brebaxe refundizu de badea",
  "item.minecraft.splash_potion.effect.weaving": "Splash Potion of Weaving",
  "item.minecraft.splash_potion.effect.wind_charged": "Splash Potion of Wind Charging",
  "item.minecraft.spruce_boat": "Barca d'abetu",
  "item.minecraft.spruce_chest_boat": "Spruce Boat with Chest",
  "item.minecraft.spyglass": "Lente",
  "item.minecraft.squid_spawn_egg": "Güevu qu'apruz a un calamar",
  "item.minecraft.stick": "Palu",
  "item.minecraft.stone_axe": "Hachu de piedra",
  "item.minecraft.stone_hoe": "Fesoria de piedra",
  "item.minecraft.stone_pickaxe": "Picu de piedra",
  "item.minecraft.stone_shovel": "Pala de piedra",
  "item.minecraft.stone_spear": "Stone Spear",
  "item.minecraft.stone_sword": "Espada de piedra",
  "item.minecraft.stray_spawn_egg": "Güevu qu'apruz a un vagamundu",
  "item.minecraft.strider_spawn_egg": "Strider Spawn Egg",
  "item.minecraft.string": "Filu",
  "item.minecraft.sugar": "Azucre",
  "item.minecraft.suspicious_stew": "Guisu sospechosu",
  "item.minecraft.sweet_berries": "Vagues dulces",
  "item.minecraft.tadpole_bucket": "Bucket of Tadpole",
  "item.minecraft.tadpole_spawn_egg": "Tadpole Spawn Egg",
  "item.minecraft.tide_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Tide Armor Trim",
  "item.minecraft.tipped_arrow": "Flecha calistrada",
  "item.minecraft.tipped_arrow.effect.awkward": "Tipped Arrow",
  "item.minecraft.tipped_arrow.effect.empty": "Flecha non ellaborable",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Flecha de resistencia al fueu",
  "item.minecraft.tipped_arrow.effect.harming": "Flecha de dañu",
  "item.minecraft.tipped_arrow.effect.healing": "Flecha de curación",
  "item.minecraft.tipped_arrow.effect.infested": "Arrow of Infestation",
  "item.minecraft.tipped_arrow.effect.invisibility": "Flecha d'invisibilidá",
  "item.minecraft.tipped_arrow.effect.leaping": "Flecha de blincu",
  "item.minecraft.tipped_arrow.effect.levitation": "Flecha de llevitación",
  "item.minecraft.tipped_arrow.effect.luck": "Flecha de suerte",
  "item.minecraft.tipped_arrow.effect.mundane": "Tipped Arrow",
  "item.minecraft.tipped_arrow.effect.night_vision": "Flecha de visión nocherniego",
  "item.minecraft.tipped_arrow.effect.oozing": "Arrow of Oozing",
  "item.minecraft.tipped_arrow.effect.poison": "Flecha velenosa",
  "item.minecraft.tipped_arrow.effect.regeneration": "Flecha de rexeneración",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Flecha de cayida lenta",
  "item.minecraft.tipped_arrow.effect.slowness": "Flecha de lentitú",
  "item.minecraft.tipped_arrow.effect.strength": "Flecha de fuercia",
  "item.minecraft.tipped_arrow.effect.swiftness": "Flecha de rapidez",
  "item.minecraft.tipped_arrow.effect.thick": "Tipped Arrow",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Flecha del maestru de tortugues",
  "item.minecraft.tipped_arrow.effect.water": "Flecha de chiscadura",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Flecha d'aliendu acuáticu",
  "item.minecraft.tipped_arrow.effect.weakness": "Flecha de badea",
  "item.minecraft.tipped_arrow.effect.weaving": "Arrow of Weaving",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Arrow of Wind Charging",
  "item.minecraft.tnt_minecart": "Vagoneta con TNT",
  "item.minecraft.torchflower_seeds": "Torchflower Seeds",
  "item.minecraft.totem_of_undying": "Tótem d'inmortalidá",
  "item.minecraft.trader_llama_spawn_egg": "Güevu qu'apruz a una llama de viaxante",
  "item.minecraft.trial_key": "Trial Key",
  "item.minecraft.trident": "Tridente",
  "item.minecraft.tropical_fish": "Pexe tropical",
  "item.minecraft.tropical_fish_bucket": "Calderu con pexe tropical",
  "item.minecraft.tropical_fish_spawn_egg": "Güevu qu'apruz a un pexe tropical",
  "item.minecraft.turtle_helmet": "Cascu de tortuga",
  "item.minecraft.turtle_scute": "Escudu de Tortuga",
  "item.minecraft.turtle_spawn_egg": "Güevu qu'apruz a una tortuga",
  "item.minecraft.vex_armor_trim_smithing_template": "Plantiya de ferrería",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Vex Armor Trim",
  "item.minecraft.vex_spawn_egg": "Güevu qu'apruz a un picuscayu",
  "item.minecraft.villager_spawn_egg": "Güevu qu'apruz a un aldeanu",
  "item.minecraft.vindicator_spawn_egg": "Güevu qu'apruz a un vindicador",
  "item.minecraft.wandering_trader_spawn_egg": "Güevu qu'apruz a un viaxante",
  "item.minecraft.ward_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Ward Armor Trim",
  "item.minecraft.warden_spawn_egg": "Güevu qu'apruz un serenu",
  "item.minecraft.warped_fungus_on_a_stick": "Fungu distorsionáu nuna caña",
  "item.minecraft.water_bucket": "Calderu con agua",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Wayfinder Armor Trim",
  "item.minecraft.wheat": "Trigu",
  "item.minecraft.wheat_seeds": "Semiente de trigu",
  "item.minecraft.white_bundle": "White Bundle",
  "item.minecraft.white_dye": "Tiñe blancu",
  "item.minecraft.white_harness": "White Harness",
  "item.minecraft.wild_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Wild Armor Trim",
  "item.minecraft.wind_charge": "Wind Charge",
  "item.minecraft.witch_spawn_egg": "Güevu qu'apruz a una bruxa",
  "item.minecraft.wither_skeleton_spawn_egg": "Güevu qu'apruz a una cadarma de wither",
  "item.minecraft.wither_spawn_egg": "Wither Spawn Egg",
  "item.minecraft.wolf_armor": "Wolf Armor",
  "item.minecraft.wolf_spawn_egg": "Güevu qu'apruz a un llobu",
  "item.minecraft.wooden_axe": "Hachu de madera",
  "item.minecraft.wooden_hoe": "Fesoria de madera",
  "item.minecraft.wooden_pickaxe": "Picu de madera",
  "item.minecraft.wooden_shovel": "Pala de madera",
  "item.minecraft.wooden_spear": "Wooden Spear",
  "item.minecraft.wooden_sword": "Espada de madera",
  "item.minecraft.writable_book": "Llibru y pluma",
  "item.minecraft.written_book": "Llibru escritu",
  "item.minecraft.yellow_bundle": "Yellow Bundle",
  "item.minecraft.yellow_dye": "Tiñe mariellu",
  "item.minecraft.yellow_harness": "Yellow Harness",
  "item.minecraft.zoglin_spawn_egg": "Güevu qu'apruz a un zoglin",
  "item.minecraft.zombie_horse_spawn_egg": "Güevu qu'apruz a un caballu zombi",
  "item.minecraft.zombie_nautilus_spawn_egg": "Zombie Nautilus Spawn Egg",
  "item.minecraft.zombie_spawn_egg": "Güevu qu'apruz a un zombi",
  "item.minecraft.zombie_villager_spawn_egg": "Güevu qu'apruz a un aldeanu zombi",
  "item.minecraft.zombified_piglin_spawn_egg": "Güevu qu'apruz a un piglin zombi"
}
export const ast_es = items; 
